// // import React, { useState, useEffect } from 'react';
// // import {
// //     FaEye, FaCheck, FaTimes, FaUndo, FaPaperPlane,
// //     FaSearch, FaSpinner, FaUsers, FaClipboardList,
// //     FaClock, FaCheckCircle, FaTimesCircle, FaSync,
// //     FaBuilding, FaUser, FaEnvelope, FaPhone,
// //     FaChevronDown, FaChevronUp, FaEdit, FaTrash
// // } from 'react-icons/fa';
// // import {
// //     getAllEnquiries,
// //     updateEnquiry,
// //     getAllVendors,
// //     sendEnquiryToVendors
// // } from '../../../Servicefile/salesService';

// // const ManagerApproval = () => {
// //     // ============================================
// //     // STATE
// //     // ============================================
// //     const [enquiries, setEnquiries] = useState([]);
// //     const [loading, setLoading] = useState(false);
// //     const [submitting, setSubmitting] = useState(false);
// //     const [searchTerm, setSearchTerm] = useState('');
// //     const [selectedEnquiry, setSelectedEnquiry] = useState(null);

// //     // Modal states
// //     const [isViewModalOpen, setIsViewModalOpen] = useState(false);
// //     const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
// //     const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
// //     const [isSendModalOpen, setIsSendModalOpen] = useState(false);

// //     // Form states
// //     const [approveComment, setApproveComment] = useState('');
// //     const [rejectReason, setRejectReason] = useState('');

// //     // Send to vendors states
// //     const [vendors, setVendors] = useState([]);
// //     const [selectedVendors, setSelectedVendors] = useState([]);
// //     const [vendorSearchTerm, setVendorSearchTerm] = useState('');
// //     const [selectAll, setSelectAll] = useState(false);
// //     const [sendingEnquiry, setSendingEnquiry] = useState(false);
// //     const [paymentAmount, setPaymentAmount] = useState('');

// //     // Stats
// //     const [stats, setStats] = useState({
// //         total: 0,
// //         pending: 0,
// //         approved: 0,
// //         rejected: 0
// //     });

// //     // ============================================
// //     // STATUS CONFIGURATION - Easy to add more statuses
// //     // ============================================
// //     const STATUS_CONFIG = {
// //         // Statuses that appear in the list
// //         DISPLAY_STATUSES: ['PENDING', 'APPROVED', 'REJECTED'],
        
// //         // Statuses that show action buttons
// //         ACTION_STATUSES: ['PENDING'],
        
// //         // Status display names
// //         DISPLAY_NAMES: {
// //             'PENDING': '⏳ Pending',
// //             'APPROVED': '✅ Approved',
// //             'REJECTED': '❌ Rejected',
// //             'PAYMENT_RECEIVED': '💰 Payment Received',
// //             'ASSIGNED': '📌 Assigned',
// //             'ACCEPT': '📥 Accept',
// //             'ACCEPTED': '✅ Accepted',
// //             'CLOSED': '📦 Closed'
// //         },
        
// //         // Status colors for badges
// //         COLORS: {
// //             'PENDING': { bg: '#FEF3C7', color: '#92400E' },
// //             'APPROVED': { bg: '#D1FAE5', color: '#065F46' },
// //             'REJECTED': { bg: '#FEE2E2', color: '#991B1B' },
// //             'PAYMENT_RECEIVED': { bg: '#DBEAFE', color: '#1E40AF' },
// //             'ASSIGNED': { bg: '#E0E7FF', color: '#3730A3' },
// //             'ACCEPT': { bg: '#FCE7F3', color: '#BE185D' },
// //             'ACCEPTED': { bg: '#D1FAE5', color: '#065F46' },
// //             'CLOSED': { bg: '#F3F4F6', color: '#4B5563' }
// //         }
// //     };

// //     // ============================================
// //     // API CALLS
// //     // ============================================
// //     const fetchEnquiries = async () => {
// //         setLoading(true);
// //         try {
// //             const data = await getAllEnquiries();
            
// //             // Filter: Only show statuses defined in DISPLAY_STATUSES
// //             const filteredData = (data || []).filter(enquiry =>
// //                 STATUS_CONFIG.DISPLAY_STATUSES.includes(enquiry.leadStatus)
// //             );
            
// //             // Sort: Newest first (by createdAt)
// //             const sortedData = filteredData.sort((a, b) => {
// //                 const dateA = new Date(a.createdAt);
// //                 const dateB = new Date(b.createdAt);
// //                 return dateB - dateA;
// //             });
            
// //             setEnquiries(sortedData);
// //             calculateStats(sortedData);
// //         } catch (error) {
// //             console.error('Error fetching enquiries:', error);
// //             alert('Failed to fetch enquiries');
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     const fetchVendors = async () => {
// //         try {
// //             const data = await getAllVendors();
// //             setVendors(data || []);
// //         } catch (error) {
// //             console.error('Error fetching vendors:', error);
// //         }
// //     };

// //     const calculateStats = (data) => {
// //         const total = data.length;
// //         const pending = data.filter(e => e.leadStatus === 'PENDING').length;
// //         const approved = data.filter(e => e.leadStatus === 'APPROVED').length;
// //         const rejected = data.filter(e => e.leadStatus === 'REJECTED').length;
// //         setStats({ total, pending, approved, rejected });
// //     };

// //     // ============================================
// //     // HANDLERS
// //     // ============================================
// //     const handleViewEnquiry = (enquiry) => {
// //         setSelectedEnquiry(enquiry);
// //         setIsViewModalOpen(true);
// //     };

// //     const handleOpenApprove = (enquiry) => {
// //         setSelectedEnquiry(enquiry);
// //         setApproveComment('');
// //         setIsApproveModalOpen(true);
// //     };

// //     const handleOpenReject = (enquiry) => {
// //         setSelectedEnquiry(enquiry);
// //         setRejectReason('');
// //         setIsRejectModalOpen(true);
// //     };

// //     const handleOpenSendModal = (enquiry) => {
// //         setSelectedEnquiry(enquiry);
// //         setSelectedVendors([]);
// //         setSelectAll(false);
// //         setVendorSearchTerm('');
// //         setPaymentAmount('');
// //         setIsSendModalOpen(true);
// //     };

// //     const handleApprove = async () => {
// //         try {
// //             setSubmitting(true);
// //             const enquiryId = selectedEnquiry.id || selectedEnquiry.enquiryId;

// //             const requestBody = {
// //                 leadStatus: 'APPROVED',
// //                 additionalRequests: approveComment || 'Approved by manager'
// //             };

// //             await updateEnquiry(enquiryId, requestBody);

// //             // Update local state
// //             const updatedEnquiries = enquiries.map(enq =>
// //                 (enq.id === enquiryId || enq.enquiryId === enquiryId)
// //                     ? { ...enq, leadStatus: 'APPROVED' }
// //                     : enq
// //             );
// //             setEnquiries(updatedEnquiries);
// //             calculateStats(updatedEnquiries);

// //             alert(`✅ Enquiry ${selectedEnquiry.enquiryId || selectedEnquiry.id} approved successfully!`);
// //             setIsApproveModalOpen(false);
// //             setSelectedEnquiry(null);
// //         } catch (error) {
// //             console.error('Error approving enquiry:', error);
// //             alert(error.response?.data?.message || 'Failed to approve enquiry');
// //         } finally {
// //             setSubmitting(false);
// //         }
// //     };

// //     const handleReject = async () => {
// //         if (!rejectReason.trim()) {
// //             alert('Please provide a reason for rejection');
// //             return;
// //         }

// //         try {
// //             setSubmitting(true);
// //             const enquiryId = selectedEnquiry.id || selectedEnquiry.enquiryId;

// //             const requestBody = {
// //                 leadStatus: 'REJECTED',
// //                 additionalRequests: rejectReason
// //             };

// //             await updateEnquiry(enquiryId, requestBody);

// //             // Update local state
// //             const updatedEnquiries = enquiries.map(enq =>
// //                 (enq.id === enquiryId || enq.enquiryId === enquiryId)
// //                     ? { ...enq, leadStatus: 'REJECTED' }
// //                     : enq
// //             );
// //             setEnquiries(updatedEnquiries);
// //             calculateStats(updatedEnquiries);

// //             alert(`❌ Enquiry ${selectedEnquiry.enquiryId || selectedEnquiry.id} rejected!`);
// //             setIsRejectModalOpen(false);
// //             setSelectedEnquiry(null);
// //             setRejectReason('');
// //         } catch (error) {
// //             console.error('Error rejecting enquiry:', error);
// //             alert(error.response?.data?.message || 'Failed to reject enquiry');
// //         } finally {
// //             setSubmitting(false);
// //         }
// //     };

// //     const handleVendorSelect = (vendorId) => {
// //         setSelectedVendors(prev => {
// //             if (prev.includes(vendorId)) {
// //                 return prev.filter(id => id !== vendorId);
// //             } else {
// //                 return [...prev, vendorId];
// //             }
// //         });
// //         setSelectAll(false);
// //     };

// //     const handleSelectAll = () => {
// //         if (selectAll) {
// //             setSelectedVendors([]);
// //         } else {
// //             const allVendorIds = filteredVendors.map(v => v.vendorId);
// //             setSelectedVendors(allVendorIds);
// //         }
// //         setSelectAll(!selectAll);
// //     };

// //     const handleSendToVendors = async () => {
// //         if (selectedVendors.length === 0) {
// //             alert('Please select at least one vendor');
// //             return;
// //         }

// //         setSendingEnquiry(true);
// //         try {
// //             let payload;

// //             if (selectAll) {
// //                 payload = {
// //                     adminPermision: true,
// //                     paymentAmount: paymentAmount || 0,
// //                     assignToAll: true
// //                 };
// //             } else {
// //                 payload = {
// //                     adminPermision: true,
// //                     paymentAmount: paymentAmount || 0,
// //                     vendorIds: selectedVendors
// //                 };
// //             }

// //             await sendEnquiryToVendors(selectedEnquiry.id || selectedEnquiry.enquiryId, payload);
// //             alert('✅ Enquiry sent to vendors successfully!');
// //             setIsSendModalOpen(false);
// //             setSelectedEnquiry(null);
// //             fetchEnquiries();
// //         } catch (error) {
// //             console.error('Error sending enquiry:', error);
// //             alert(error.response?.data?.message || 'Failed to send enquiry to vendors');
// //         } finally {
// //             setSendingEnquiry(false);
// //         }
// //     };

// //     // ============================================
// //     // FILTERS
// //     // ============================================
// //     const filteredEnquiries = enquiries.filter(enquiry => {
// //         const matchesSearch =
// //             (enquiry.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             (enquiry.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             (enquiry.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             (enquiry.city || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             (enquiry.enquiryId || enquiry.id || '').toString().includes(searchTerm);

// //         return matchesSearch;
// //     });

// //     const filteredVendors = vendors.filter(vendor =>
// //         (vendor.registeredName || '').toLowerCase().includes(vendorSearchTerm.toLowerCase()) ||
// //         (vendor.vendorId || '').toString().includes(vendorSearchTerm)
// //     );

// //     // ============================================
// //     // FORMAT HELPERS
// //     // ============================================
// //     const formatDate = (dateStr) => {
// //         if (!dateStr) return '-';
// //         try {
// //             const date = new Date(dateStr);
// //             return date.toLocaleDateString('en-IN', {
// //                 day: '2-digit',
// //                 month: 'short',
// //                 year: 'numeric'
// //             });
// //         } catch {
// //             return dateStr;
// //         }
// //     };

// //     const formatCurrency = (amount) => {
// //         if (!amount) return '₹0';
// //         return `₹${Number(amount).toLocaleString()}`;
// //     };

// //     const getStatusBadge = (status) => {
// //         const colors = STATUS_CONFIG.COLORS[status] || STATUS_CONFIG.COLORS['PENDING'];
// //         const displayName = STATUS_CONFIG.DISPLAY_NAMES[status] || status;
        
// //         return (
// //             <span style={{
// //                 display: 'inline-flex',
// //                 alignItems: 'center',
// //                 gap: '4px',
// //                 padding: '4px 12px',
// //                 borderRadius: '20px',
// //                 fontSize: '11px',
// //                 fontWeight: 600,
// //                 background: colors.bg,
// //                 color: colors.color
// //             }}>
// //                 {displayName}
// //             </span>
// //         );
// //     };

// //     // Check if status allows actions
// //     const hasActions = (status) => {
// //         return STATUS_CONFIG.ACTION_STATUSES.includes(status);
// //     };

// //     // ============================================
// //     // EFFECTS
// //     // ============================================
// //     useEffect(() => {
// //         fetchEnquiries();
// //         fetchVendors();
// //     }, []);

// //     // ============================================
// //     // RENDER
// //     // ============================================
// //     return (
// //         <div style={containerStyle}>
// //             {/* Header */}
// //             <div style={headerStyle}>
// //                 <div style={headerLeftStyle}>
// //                     <div style={headerIconStyle}>
// //                         <FaClipboardList size={22} />
// //                     </div>
// //                     <div>
// //                         <h2 style={titleStyle}>Manager Approvals</h2>
// //                         <p style={subtitleStyle}>Review and approve quotes from sales team</p>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Stats Cards */}
// //             <div style={statsContainerStyle}>
// //                 <div style={statCardStyle}>
// //                     <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
// //                         <FaClipboardList style={{ color: '#4F46E5' }} size={20} />
// //                     </div>
// //                     <div>
// //                         <div style={statNumberStyle}>{stats.total}</div>
// //                         <div style={statLabelStyle}>Total</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={{ ...statIconWrapperStyle, background: '#FEF3C7' }}>
// //                         <FaClock style={{ color: '#D97706' }} size={20} />
// //                     </div>
// //                     <div>
// //                         <div style={statNumberStyle}>{stats.pending}</div>
// //                         <div style={statLabelStyle}>Pending</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
// //                         <FaCheckCircle style={{ color: '#059669' }} size={20} />
// //                     </div>
// //                     <div>
// //                         <div style={statNumberStyle}>{stats.approved}</div>
// //                         <div style={statLabelStyle}>Approved</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={{ ...statIconWrapperStyle, background: '#FEE2E2' }}>
// //                         <FaTimesCircle style={{ color: '#DC2626' }} size={20} />
// //                     </div>
// //                     <div>
// //                         <div style={statNumberStyle}>{stats.rejected}</div>
// //                         <div style={statLabelStyle}>Rejected</div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Search */}
// //             <div style={searchFilterContainerStyle}>
// //                 <div style={searchContainerStyle}>
// //                     <FaSearch style={searchIconStyle} />
// //                     <input
// //                         type="text"
// //                         placeholder="Search by name, email, company, enquiry ID..."
// //                         value={searchTerm}
// //                         onChange={(e) => setSearchTerm(e.target.value)}
// //                         style={searchInputStyle}
// //                     />
// //                 </div>
// //             </div>

// //             {/* Table */}
// //             <div style={tableCardStyle}>
// //                 {loading ? (
// //                     <div style={loadingStyle}>
// //                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
// //                         <p>Loading enquiries...</p>
// //                     </div>
// //                 ) : (
// //                     <div style={tableWrapperStyle}>
// //                         <table style={tableStyle}>
// //                             <thead>
// //                                 <tr>
// //                                     <th style={{ ...thStyle, width: '3%', textAlign: 'center' }}>#</th>
// //                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Enquiry ID</th>
// //                                     <th style={{ ...thStyle, width: '12%', textAlign: 'left' }}>Customer</th>
// //                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Event</th>
// //                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Date</th>
// //                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>City</th>
// //                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Budget</th>
// //                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Status</th>
// //                                     <th style={{ ...thStyle, width: '29%', textAlign: 'center' }}>Actions</th>
// //                                 </tr>
// //                             </thead>
// //                             <tbody>
// //                                 {filteredEnquiries.length === 0 ? (
// //                                     <tr>
// //                                         <td colSpan="9" style={emptyStateStyle}>
// //                                             <div style={emptyStateContentStyle}>
// //                                                 <FaClipboardList size={40} color="#D1D5DB" />
// //                                                 <p>No enquiries found</p>
// //                                                 <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
// //                                                     {searchTerm ? 'Try adjusting your search terms' : 'No enquiries pending for approval'}
// //                                                 </span>
// //                                             </div>
// //                                         </td>
// //                                     </tr>
// //                                 ) : (
// //                                     filteredEnquiries.map((enquiry, index) => (
// //                                         <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
// //                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
// //                                                 {index + 1}
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#4F46E5', fontSize: '12px' }}>
// //                                                 {enquiry.enquiryId || enquiry.id || '-'}
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'left' }}>
// //                                                 <div style={customerCellStyle}>
// //                                                     <div style={avatarStyle}>
// //                                                         {(enquiry.fullName || '?')[0].toUpperCase()}
// //                                                     </div>
// //                                                     <div>
// //                                                         <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
// //                                                             {enquiry.fullName || '-'}
// //                                                         </div>
// //                                                         <div style={{ fontSize: '12px', color: '#6B7280' }}>
// //                                                             {enquiry.email || '-'}
// //                                                         </div>
// //                                                     </div>
// //                                                 </div>
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
// //                                                 <span style={eventBadgeStyle}>
// //                                                     {enquiry.eventType || '-'}
// //                                                 </span>
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px', color: '#374151' }}>
// //                                                 {enquiry.event === 'EVENT'
// //                                                     ? formatDate(enquiry.eventDate)
// //                                                     : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
// //                                                 <span style={cityBadgeStyle}>
// //                                                     {enquiry.city || '-'}
// //                                                 </span>
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
// //                                                 {formatCurrency(enquiry.budget)}
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
// //                                                 {getStatusBadge(enquiry.leadStatus)}
// //                                             </td>
// //                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
// //                                                 <div style={actionGroupStyle}>
// //                                                     <button
// //                                                         style={viewButtonStyle}
// //                                                         title="View Details"
// //                                                         onClick={() => handleViewEnquiry(enquiry)}
// //                                                     >
// //                                                         <FaEye size={13} /> View
// //                                                     </button>
// //                                                     {hasActions(enquiry.leadStatus) && (
// //                                                         <>
// //                                                             <button
// //                                                                 style={approveButtonStyle}
// //                                                                 title="Approve"
// //                                                                 onClick={() => handleOpenApprove(enquiry)}
// //                                                             >
// //                                                                 <FaCheck size={13} /> Approve
// //                                                             </button>
// //                                                             <button
// //                                                                 style={rejectButtonStyle}
// //                                                                 title="Reject"
// //                                                                 onClick={() => handleOpenReject(enquiry)}
// //                                                             >
// //                                                                 <FaTimes size={13} /> Reject
// //                                                             </button>
// //                                                             <button
// //                                                                 style={sendButtonStyle}
// //                                                                 title="Send to Vendors"
// //                                                                 onClick={() => handleOpenSendModal(enquiry)}
// //                                                             >
// //                                                                 <FaPaperPlane size={13} /> Send
// //                                                             </button>
// //                                                         </>
// //                                                     )}
// //                                                 </div>
// //                                             </td>
// //                                         </tr>
// //                                     ))
// //                                 )}
// //                             </tbody>
// //                         </table>
// //                     </div>
// //                 )}
// //             </div>

// //             {/* ============================================ */}
// //             {/* MODALS - Same as before */}
// //             {/* ============================================ */}

// //             {/* View Enquiry Modal */}
// //             {isViewModalOpen && selectedEnquiry && (
// //                 <div style={modalOverlayStyle} onClick={() => setIsViewModalOpen(false)}>
// //                     <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
// //                         <div style={modalHeaderStyle}>
// //                             <div style={modalHeaderLeftStyle}>
// //                                 <div style={modalHeaderIconStyle}>
// //                                     <FaEye size={18} />
// //                                 </div>
// //                                 <h3 style={modalTitleStyle}>Enquiry Details - {selectedEnquiry.enquiryId || selectedEnquiry.id}</h3>
// //                             </div>
// //                             <button onClick={() => setIsViewModalOpen(false)} style={modalCloseStyle}>
// //                                 <FaTimes />
// //                             </button>
// //                         </div>

// //                         <div style={modalBodyStyle}>
// //                             <div style={viewSectionStyle}>
// //                                 <h4 style={viewSectionTitleStyle}>Contact Information</h4>
// //                                 <div style={viewGridStyle}>
// //                                     <div><strong>Name:</strong> {selectedEnquiry.fullName || '-'}</div>
// //                                     <div><strong>Company:</strong> {selectedEnquiry.companyName || '-'}</div>
// //                                     <div><strong>Email:</strong> {selectedEnquiry.email || '-'}</div>
// //                                     <div><strong>Phone:</strong> {selectedEnquiry.phoneNumber || '-'}</div>
// //                                     <div><strong>City:</strong> {selectedEnquiry.city || '-'}</div>
// //                                     <div><strong>State:</strong> {selectedEnquiry.state || '-'}</div>
// //                                 </div>
// //                             </div>

// //                             <div style={viewSectionStyle}>
// //                                 <h4 style={viewSectionTitleStyle}>Enquiry Information</h4>
// //                                 <div style={viewGridStyle}>
// //                                     <div><strong>Source:</strong> {selectedEnquiry.source || '-'}</div>
// //                                     <div><strong>Source By:</strong> {selectedEnquiry.sourceBy || '-'}</div>
// //                                     <div><strong>Event:</strong> {selectedEnquiry.eventType || '-'}</div>
// //                                     <div><strong>Event Date:</strong> {formatDate(selectedEnquiry.eventDate)}</div>
// //                                     <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
// //                                     <div><strong>Status:</strong> {getStatusBadge(selectedEnquiry.leadStatus)}</div>
// //                                 </div>
// //                             </div>

// //                             <div style={viewSectionStyle}>
// //                                 <h4 style={viewSectionTitleStyle}>Additional Details</h4>
// //                                 <div style={viewGridStyle}>
// //                                     <div><strong>Veg Plates:</strong> {selectedEnquiry.vegPlates || 0}</div>
// //                                     <div><strong>Non-Veg Plates:</strong> {selectedEnquiry.nonVegPlates || 0}</div>
// //                                     <div><strong>Mixed Plates:</strong> {selectedEnquiry.mixedPlates || 0}</div>
// //                                     <div style={{ gridColumn: '1 / -1' }}>
// //                                         <strong>Address:</strong> {selectedEnquiry.fullAddress || '-'}
// //                                     </div>
// //                                     <div style={{ gridColumn: '1 / -1' }}>
// //                                         <strong>Additional Requests:</strong> {selectedEnquiry.additionalRequests || '-'}
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         </div>

// //                         <div style={formActionStyle}>
// //                             <button
// //                                 onClick={() => setIsViewModalOpen(false)}
// //                                 style={cancelButtonStyle}
// //                             >
// //                                 Close
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Approve Modal */}
// //             {isApproveModalOpen && selectedEnquiry && (
// //                 <div style={modalOverlayStyle} onClick={() => setIsApproveModalOpen(false)}>
// //                     <div style={{ ...modalStyle, maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
// //                         <div style={modalHeaderStyle}>
// //                             <div style={modalHeaderLeftStyle}>
// //                                 <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #10B981, #059669)' }}>
// //                                     <FaCheck size={18} />
// //                                 </div>
// //                                 <h3 style={modalTitleStyle}>Approve Enquiry</h3>
// //                             </div>
// //                             <button onClick={() => setIsApproveModalOpen(false)} style={modalCloseStyle}>
// //                                 <FaTimes />
// //                             </button>
// //                         </div>

// //                         <div style={modalBodyStyle}>
// //                             <div style={approvalInfoStyle}>
// //                                 <div><strong>Enquiry:</strong> {selectedEnquiry.enquiryId || selectedEnquiry.id}</div>
// //                                 <div><strong>Customer:</strong> {selectedEnquiry.fullName}</div>
// //                                 <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
// //                             </div>

// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Comments (Optional)</label>
// //                                 <textarea
// //                                     value={approveComment}
// //                                     onChange={(e) => setApproveComment(e.target.value)}
// //                                     rows="3"
// //                                     placeholder="Add any comments or notes for the sales team..."
// //                                     style={textareaStyle}
// //                                 />
// //                             </div>
// //                         </div>

// //                         <div style={formActionStyle}>
// //                             <button
// //                                 onClick={() => setIsApproveModalOpen(false)}
// //                                 style={cancelButtonStyle}
// //                             >
// //                                 Cancel
// //                             </button>
// //                             <button
// //                                 onClick={handleApprove}
// //                                 style={approveSubmitButtonStyle}
// //                                 disabled={submitting}
// //                             >
// //                                 {submitting ? (
// //                                     <>
// //                                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
// //                                         Approving...
// //                                     </>
// //                                 ) : (
// //                                     <>
// //                                         <FaCheck size={14} />
// //                                         Confirm Approve
// //                                     </>
// //                                 )}
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Reject Modal */}
// //             {isRejectModalOpen && selectedEnquiry && (
// //                 <div style={modalOverlayStyle} onClick={() => setIsRejectModalOpen(false)}>
// //                     <div style={{ ...modalStyle, maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
// //                         <div style={modalHeaderStyle}>
// //                             <div style={modalHeaderLeftStyle}>
// //                                 <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #EF4444, #DC2626)' }}>
// //                                     <FaTimes size={18} />
// //                                 </div>
// //                                 <h3 style={modalTitleStyle}>Reject Enquiry</h3>
// //                             </div>
// //                             <button onClick={() => setIsRejectModalOpen(false)} style={modalCloseStyle}>
// //                                 <FaTimes />
// //                             </button>
// //                         </div>

// //                         <div style={modalBodyStyle}>
// //                             <div style={approvalInfoStyle}>
// //                                 <div><strong>Enquiry:</strong> {selectedEnquiry.enquiryId || selectedEnquiry.id}</div>
// //                                 <div><strong>Customer:</strong> {selectedEnquiry.fullName}</div>
// //                                 <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
// //                             </div>

// //                             <div style={formGroupStyle}>
// //                                 <label style={{ ...labelStyle, color: '#EF4444' }}>Rejection Reason <span style={{ color: '#EF4444' }}>*</span></label>
// //                                 <textarea
// //                                     value={rejectReason}
// //                                     onChange={(e) => setRejectReason(e.target.value)}
// //                                     rows="4"
// //                                     placeholder="Please provide a detailed reason for rejection..."
// //                                     style={textareaStyle}
// //                                     required
// //                                 />
// //                             </div>
// //                         </div>

// //                         <div style={formActionStyle}>
// //                             <button
// //                                 onClick={() => setIsRejectModalOpen(false)}
// //                                 style={cancelButtonStyle}
// //                             >
// //                                 Cancel
// //                             </button>
// //                             <button
// //                                 onClick={handleReject}
// //                                 style={rejectSubmitButtonStyle}
// //                                 disabled={submitting || !rejectReason.trim()}
// //                             >
// //                                 {submitting ? (
// //                                     <>
// //                                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
// //                                         Rejecting...
// //                                     </>
// //                                 ) : (
// //                                     <>
// //                                         <FaTimes size={14} />
// //                                         Confirm Reject
// //                                     </>
// //                                 )}
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Send to Vendors Modal */}
// //             {isSendModalOpen && selectedEnquiry && (
// //                 <div style={modalOverlayStyle} onClick={() => setIsSendModalOpen(false)}>
// //                     <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
// //                         <div style={modalHeaderStyle}>
// //                             <div style={modalHeaderLeftStyle}>
// //                                 <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)' }}>
// //                                     <FaPaperPlane size={18} />
// //                                 </div>
// //                                 <h3 style={modalTitleStyle}>Send to Vendors</h3>
// //                             </div>
// //                             <button onClick={() => setIsSendModalOpen(false)} style={modalCloseStyle}>
// //                                 <FaTimes />
// //                             </button>
// //                         </div>

// //                         <div style={modalBodyStyle}>
// //                             {/* Enquiry Info */}
// //                             <div style={sendEnquiryInfoStyle}>
// //                                 <div style={sendEnquiryInfoItemStyle}>
// //                                     <span style={{ fontWeight: 500 }}>Customer:</span>
// //                                     <span>{selectedEnquiry.fullName}</span>
// //                                 </div>
// //                                 <div style={sendEnquiryInfoItemStyle}>
// //                                     <span style={{ fontWeight: 500 }}>Event:</span>
// //                                     <span>{selectedEnquiry.eventType}</span>
// //                                 </div>
// //                                 <div style={sendEnquiryInfoItemStyle}>
// //                                     <span style={{ fontWeight: 500 }}>Budget:</span>
// //                                     <span style={{ color: '#059669', fontWeight: 600 }}>{formatCurrency(selectedEnquiry.budget)}</span>
// //                                 </div>
// //                             </div>

// //                             {/* Payment Amount */}
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Lead Price</label>
// //                                 <input
// //                                     type="number"
// //                                     value={paymentAmount}
// //                                     onChange={(e) => setPaymentAmount(e.target.value)}
// //                                     style={inputStyle}
// //                                     placeholder="Enter Lead Price"
// //                                 />
// //                             </div>

// //                             {/* Vendor Search */}
// //                             <div style={{ ...searchContainerStyle, marginBottom: '12px', marginTop: '12px' }}>
// //                                 <FaSearch style={searchIconStyle} />
// //                                 <input
// //                                     type="text"
// //                                     placeholder="Search vendors..."
// //                                     value={vendorSearchTerm}
// //                                     onChange={(e) => setVendorSearchTerm(e.target.value)}
// //                                     style={searchInputStyle}
// //                                 />
// //                             </div>

// //                             {/* Select All */}
// //                             <div style={selectAllContainerStyle}>
// //                                 <label style={selectAllLabelStyle}>
// //                                     <input
// //                                         type="checkbox"
// //                                         checked={selectAll}
// //                                         onChange={handleSelectAll}
// //                                         style={checkboxStyle}
// //                                     />
// //                                     <span style={{ fontWeight: 600 }}>Select All Vendors</span>
// //                                 </label>
// //                                 <span style={{ fontSize: '12px', color: '#6B7280' }}>
// //                                     {selectAll ? 'All vendors selected' : `${selectedVendors.length} selected`}
// //                                 </span>
// //                             </div>

// //                             {/* Vendor List */}
// //                             <div style={vendorListStyle}>
// //                                 {filteredVendors.length === 0 ? (
// //                                     <div style={noVendorsStyle}>No vendors found</div>
// //                                 ) : (
// //                                     filteredVendors.map(vendor => (
// //                                         <label key={vendor.vendorId} style={vendorItemStyle}>
// //                                             <input
// //                                                 type="checkbox"
// //                                                 checked={selectedVendors.includes(vendor.vendorId)}
// //                                                 onChange={() => handleVendorSelect(vendor.vendorId)}
// //                                                 style={checkboxStyle}
// //                                             />
// //                                             <div>
// //                                                 <div style={{ fontWeight: 500, fontSize: '14px' }}>
// //                                                     {vendor.registeredName || 'Unnamed Vendor'}
// //                                                 </div>
// //                                                 <div style={{ fontSize: '12px', color: '#6B7280' }}>
// //                                                     {vendor.city || 'City not specified'} • {vendor.mobileNumber || 'No phone'}
// //                                                 </div>
// //                                             </div>
// //                                         </label>
// //                                     ))
// //                                 )}
// //                             </div>

// //                             {/* Actions */}
// //                             <div style={formActionStyle}>
// //                                 <button
// //                                     type="button"
// //                                     onClick={() => setIsSendModalOpen(false)}
// //                                     style={cancelButtonStyle}
// //                                 >
// //                                     Cancel
// //                                 </button>
// //                                 <button
// //                                     type="button"
// //                                     onClick={handleSendToVendors}
// //                                     style={sendSubmitButtonStyle}
// //                                     disabled={sendingEnquiry || selectedVendors.length === 0}
// //                                 >
// //                                     {sendingEnquiry ? (
// //                                         <>
// //                                             <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
// //                                             Sending...
// //                                         </>
// //                                     ) : (
// //                                         <>
// //                                             <FaPaperPlane size={14} />
// //                                             Send to {selectedVendors.length} Vendor{selectedVendors.length > 1 ? 's' : ''}
// //                                         </>
// //                                     )}
// //                                 </button>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             <style>{`
// //                 @keyframes spin { to { transform: rotate(360deg); } }
// //                 @keyframes fadeIn {
// //                     from { opacity: 0; transform: translateY(-10px); }
// //                     to { opacity: 1; transform: translateY(0); }
// //                 }
// //                 @keyframes slideUp {
// //                     from { opacity: 0; transform: translateY(20px); }
// //                     to { opacity: 1; transform: translateY(0); }
// //                 }
// //             `}</style>
// //         </div>
// //     );
// // };

// // // ─── Styles ──────────────────────────────────────────────────────
// // // (All styles remain the same as before)

// // const containerStyle = {
// //     fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
// //     height:"65vh"
// // };

// // const headerStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     marginBottom: '24px',
// //     flexWrap: 'wrap',
// //     gap: '16px',
// // };

// // const headerLeftStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '16px',
// // };

// // const headerIconStyle = {
// //     width: '44px',
// //     height: '44px',
// //     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
// //     borderRadius: '12px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     color: '#fff',
// // };

// // const titleStyle = {
// //     fontSize: '24px',
// //     fontWeight: 700,
// //     color: '#111827',
// //     margin: 0,
// //     letterSpacing: '-0.5px',
// // };

// // const subtitleStyle = {
// //     fontSize: '14px',
// //     color: '#6B7280',
// //     margin: '4px 0 0 0',
// // };

// // // Stats Styles
// // const statsContainerStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: 'repeat(4, 1fr)',
// //     gap: '16px',
// //     marginBottom: '20px',
// // };

// // const statCardStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '16px',
// //     background: '#fff',
// //     padding: '18px 20px',
// //     borderRadius: '12px',
// //     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
// //     border: '1px solid #E5E7EB',
// //     transition: 'all 0.2s ease',
// // };

// // const statIconWrapperStyle = {
// //     width: '44px',
// //     height: '44px',
// //     borderRadius: '10px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// // };

// // const statNumberStyle = {
// //     fontSize: '22px',
// //     fontWeight: 700,
// //     color: '#111827',
// //     lineHeight: 1.2,
// // };

// // const statLabelStyle = {
// //     fontSize: '13px',
// //     color: '#6B7280',
// //     fontWeight: 500,
// // };

// // // Search Styles
// // const searchFilterContainerStyle = {
// //     display: 'flex',
// //     gap: '12px',
// //     marginBottom: '20px',
// //     flexWrap: 'wrap',
// //     alignItems: 'center',
// // };

// // const searchContainerStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     flex: 1,
// //     minWidth: '200px',
// //     background: '#fff',
// //     border: '1px solid #E5E7EB',
// //     borderRadius: '10px',
// //     padding: '0 16px',
// //     transition: 'all 0.2s ease',
// // };

// // const searchIconStyle = {
// //     color: '#9CA3AF',
// //     marginRight: '12px',
// // };

// // const searchInputStyle = {
// //     flex: 1,
// //     padding: '11px 0',
// //     border: 'none',
// //     outline: 'none',
// //     fontSize: '14px',
// //     background: 'transparent',
// //     color: '#111827',
// // };

// // // Table Styles
// // const tableCardStyle = {
// //     background: '#fff',
// //     borderRadius: '12px',
// //     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
// //     overflow: 'hidden',
// //     border: '1px solid #E5E7EB',
// // };

// // const tableWrapperStyle = {
// //     overflowX: 'auto',
// //     padding: '0',
// //     maxHeight: '60vh',
// //     overflowY: 'auto',
// //     scrollbarWidth:"thin"
// // };

// // const tableStyle = {
// //     width: '100%',
// //     borderCollapse: 'collapse',
// //     minWidth: '1100px',
// // };

// // const thStyle = {
// //     padding: '12px 16px',
// //     fontSize: '12px',
// //     fontWeight: 600,
// //     color: '#6B7280',
// //     textTransform: 'uppercase',
// //     letterSpacing: '0.5px',
// //     background: '#F9FAFB',
// //     borderBottom: '1px solid #E5E7EB',
// //     position: 'sticky',
// //     top: 0,
// //     zIndex: 10,
// // };

// // const tdStyle = {
// //     padding: '12px 16px',
// //     fontSize: '13px',
// //     color: '#111827',
// //     borderBottom: '1px solid #F3F4F6',
// // };

// // const tableRowStyle = {
// //     transition: 'background 0.15s ease',
// //     cursor: 'default',
// // };

// // const customerCellStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '10px',
// // };

// // const avatarStyle = {
// //     width: '32px',
// //     height: '32px',
// //     borderRadius: '50%',
// //     background: 'linear-gradient(135deg, #e66d33, #d45a2a)',
// //     color: '#fff',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     fontSize: '13px',
// //     fontWeight: 600,
// //     flexShrink: 0,
// // };

// // const eventBadgeStyle = {
// //     display: 'inline-block',
// //     padding: '2px 10px',
// //     background: '#F3F4F6',
// //     borderRadius: '6px',
// //     fontSize: '12px',
// //     fontWeight: 500,
// //     color: '#4B5563',
// // };

// // const cityBadgeStyle = {
// //     display: 'inline-block',
// //     padding: '2px 10px',
// //     background: '#EEF2FF',
// //     borderRadius: '6px',
// //     fontSize: '12px',
// //     fontWeight: 500,
// //     color: '#4F46E5',
// // };

// // // Action Buttons
// // const actionGroupStyle = {
// //     display: 'flex',
// //     gap: '6px',
// //     justifyContent: 'center',
// //     flexWrap: 'wrap',
// // };

// // const viewButtonStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '5px 12px',
// //     background: '#60A5FA',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     fontSize: '12px',
// //     fontWeight: 500,
// //     transition: 'all 0.2s ease',
// // };

// // const approveButtonStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '5px 12px',
// //     background: '#10B981',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     fontSize: '12px',
// //     fontWeight: 500,
// //     transition: 'all 0.2s ease',
// // };

// // const rejectButtonStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '5px 12px',
// //     background: '#EF4444',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     fontSize: '12px',
// //     fontWeight: 500,
// //     transition: 'all 0.2s ease',
// // };

// // const sendButtonStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '5px 12px',
// //     background: '#8B5CF6',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     fontSize: '12px',
// //     fontWeight: 500,
// //     transition: 'all 0.2s ease',
// // };

// // // Empty State
// // const emptyStateStyle = {
// //     padding: '60px 20px',
// //     textAlign: 'center',
// //     borderBottom: 'none',
// // };

// // const emptyStateContentStyle = {
// //     display: 'flex',
// //     flexDirection: 'column',
// //     alignItems: 'center',
// //     gap: '8px',
// // };

// // const loadingStyle = {
// //     padding: '60px 20px',
// //     textAlign: 'center',
// //     display: 'flex',
// //     flexDirection: 'column',
// //     alignItems: 'center',
// //     gap: '12px',
// //     color: '#6B7280',
// // };

// // // Modal Styles
// // const modalOverlayStyle = {
// //     position: 'fixed',
// //     top: 0,
// //     left: 0,
// //     right: 0,
// //     bottom: 0,
// //     background: 'rgba(0,0,0,0.5)',
// //     backdropFilter: 'blur(4px)',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     zIndex: 9999,
// //     padding: '20px',
// //     animation: 'fadeIn 0.25s ease',
// // };

// // const modalStyle = {
// //     background: '#fff',
// //     borderRadius: '16px',
// //     width: '100%',
// //     maxWidth: '720px',
// //     maxHeight: '90vh',
// //     overflow: 'auto',
// //     boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
// //     animation: 'slideUp 0.3s ease',
// // };

// // const modalHeaderStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: '20px 24px',
// //     borderBottom: '1px solid #F3F4F6',
// //     position: 'sticky',
// //     top: 0,
// //     background: '#fff',
// //     zIndex: 1,
// // };

// // const modalHeaderLeftStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '12px',
// // };

// // const modalHeaderIconStyle = {
// //     width: '36px',
// //     height: '36px',
// //     borderRadius: '10px',
// //     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     color: '#fff',
// // };

// // const modalTitleStyle = {
// //     margin: 0,
// //     fontSize: '18px',
// //     fontWeight: 700,
// //     color: '#111827',
// // };

// // const modalCloseStyle = {
// //     background: '#F3F4F6',
// //     border: 'none',
// //     fontSize: '16px',
// //     cursor: 'pointer',
// //     color: '#6B7280',
// //     padding: '6px 10px',
// //     borderRadius: '8px',
// //     transition: 'all 0.2s ease',
// // };

// // const modalBodyStyle = {
// //     padding: '24px',
// // };

// // // View Styles
// // const viewSectionStyle = {
// //     border: '1px solid #F3F4F6',
// //     borderRadius: '8px',
// //     padding: '14px 16px',
// //     marginBottom: '12px',
// // };

// // const viewSectionTitleStyle = {
// //     margin: '0 0 10px 0',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     color: '#1E293B',
// // };

// // const viewGridStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: '1fr 1fr',
// //     gap: '8px 16px',
// // };

// // // Form Styles
// // const formGroupStyle = {
// //     display: 'flex',
// //     flexDirection: 'column',
// //     gap: '5px',
// //     marginBottom: '16px',
// // };

// // const labelStyle = {
// //     fontSize: '13px',
// //     fontWeight: 500,
// //     color: '#374151',
// // };

// // const inputStyle = {
// //     padding: '10px 12px',
// //     border: '1px solid #E5E7EB',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     outline: 'none',
// //     transition: 'all 0.2s ease',
// //     background: '#fff',
// //     color: '#111827',
// // };

// // const textareaStyle = {
// //     padding: '10px 12px',
// //     border: '1px solid #E5E7EB',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     outline: 'none',
// //     transition: 'all 0.2s ease',
// //     background: '#fff',
// //     color: '#111827',
// //     resize: 'vertical',
// //     fontFamily: 'inherit',
// //     width: '100%',
// // };

// // const formActionStyle = {
// //     display: 'flex',
// //     gap: '12px',
// //     justifyContent: 'flex-end',
// //     marginTop: '8px',
// //     paddingTop: '16px',
// //     borderTop: '1px solid #F3F4F6',
// // };

// // const cancelButtonStyle = {
// //     padding: '10px 24px',
// //     background: '#F3F4F6',
// //     color: '#4B5563',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 500,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const approveSubmitButtonStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 28px',
// //     background: 'linear-gradient(135deg, #10B981, #059669)',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// //     boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
// // };

// // const rejectSubmitButtonStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 28px',
// //     background: 'linear-gradient(135deg, #EF4444, #DC2626)',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// //     boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
// // };

// // const sendSubmitButtonStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 28px',
// //     background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// //     boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)',
// // };

// // // Approval Info
// // const approvalInfoStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: '1fr 1fr 1fr',
// //     gap: '12px',
// //     padding: '12px 16px',
// //     background: '#F9FAFB',
// //     borderRadius: '8px',
// //     marginBottom: '16px',
// //     border: '1px solid #E5E7EB',
// // };

// // // Send to Vendors Styles
// // const sendEnquiryInfoStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: 'repeat(3, 1fr)',
// //     gap: '12px',
// //     padding: '12px 16px',
// //     background: '#F9FAFB',
// //     borderRadius: '8px',
// //     marginBottom: '16px',
// //     border: '1px solid #E5E7EB',
// // };

// // const sendEnquiryInfoItemStyle = {
// //     display: 'flex',
// //     flexDirection: 'column',
// //     gap: '2px',
// //     fontSize: '13px',
// // };

// // const selectAllContainerStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: '8px 12px',
// //     background: '#F9FAFB',
// //     borderRadius: '8px',
// //     border: '1px solid #E5E7EB',
// //     marginBottom: '12px',
// // };

// // const selectAllLabelStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     cursor: 'pointer',
// //     fontSize: '14px',
// // };

// // const checkboxStyle = {
// //     width: '16px',
// //     height: '16px',
// //     accentColor: '#e66d33',
// //     cursor: 'pointer',
// // };

// // const vendorListStyle = {
// //     maxHeight: '250px',
// //     overflowY: 'auto',
// //     border: '1px solid #E5E7EB',
// //     borderRadius: '8px',
// //     padding: '4px',
// // };

// // const vendorItemStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '12px',
// //     padding: '10px 12px',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// //     borderBottom: '1px solid #F3F4F6',
// // };

// // const noVendorsStyle = {
// //     padding: '20px',
// //     textAlign: 'center',
// //     color: '#9CA3AF',
// //     fontSize: '14px',
// // };

// // export default ManagerApproval;



// import React, { useState, useEffect } from 'react';
// import {
//     FaEye, FaCheck, FaTimes, FaUndo, FaPaperPlane,
//     FaSearch, FaSpinner, FaUsers, FaClipboardList,
//     FaClock, FaCheckCircle, FaTimesCircle, FaSync,
//     FaBuilding, FaUser, FaEnvelope, FaPhone,
//     FaChevronDown, FaChevronUp, FaEdit, FaTrash,
//     FaCalendarAlt
// } from 'react-icons/fa';
// import {
//     getAllEnquiries,
//     updateEnquiry,
//     getAllVendors,
//     sendEnquiryToVendors
// } from '../../../Servicefile/salesService';

// const ManagerApproval = () => {
//     // ============================================
//     // STATE
//     // ============================================
//     const [enquiries, setEnquiries] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [submitting, setSubmitting] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedEnquiry, setSelectedEnquiry] = useState(null);

//     // Date filter state
//     const [dateFilter, setDateFilter] = useState('ALL'); // ALL, TODAY, YESTERDAY, WEEK, CUSTOM
//     const [customStartDate, setCustomStartDate] = useState('');
//     const [customEndDate, setCustomEndDate] = useState('');
//     const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);

//     // Modal states
//     const [isViewModalOpen, setIsViewModalOpen] = useState(false);
//     const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
//     const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
//     const [isSendModalOpen, setIsSendModalOpen] = useState(false);

//     // Form states
//     const [approveComment, setApproveComment] = useState('');
//     const [rejectReason, setRejectReason] = useState('');

//     // Send to vendors states
//     const [vendors, setVendors] = useState([]);
//     const [selectedVendors, setSelectedVendors] = useState([]);
//     const [vendorSearchTerm, setVendorSearchTerm] = useState('');
//     const [selectAll, setSelectAll] = useState(false);
//     const [sendingEnquiry, setSendingEnquiry] = useState(false);
//     const [paymentAmount, setPaymentAmount] = useState('');

//     // Stats
//     const [stats, setStats] = useState({
//         total: 0,
//         pending: 0,
//         approved: 0,
//         rejected: 0
//     });

//     // ============================================
//     // STATUS CONFIGURATION
//     // ============================================
//     const STATUS_CONFIG = {
//         DISPLAY_STATUSES: ['PENDING', 'APPROVED', 'REJECTED'],
//         ACTION_STATUSES: ['PENDING'],
//         DISPLAY_NAMES: {
//             'PENDING': '⏳ Pending',
//             'APPROVED': '✅ Approved',
//             'REJECTED': '❌ Rejected',
//             'PAYMENT_RECEIVED': '💰 Payment Received',
//             'ASSIGNED': '📌 Assigned',
//             'ACCEPT': '📥 Accept',
//             'ACCEPTED': '✅ Accepted',
//             'CLOSED': '📦 Closed'
//         },
//         COLORS: {
//             'PENDING': { bg: '#FEF3C7', color: '#92400E' },
//             'APPROVED': { bg: '#D1FAE5', color: '#065F46' },
//             'REJECTED': { bg: '#FEE2E2', color: '#991B1B' },
//             'PAYMENT_RECEIVED': { bg: '#DBEAFE', color: '#1E40AF' },
//             'ASSIGNED': { bg: '#E0E7FF', color: '#3730A3' },
//             'ACCEPT': { bg: '#FCE7F3', color: '#BE185D' },
//             'ACCEPTED': { bg: '#D1FAE5', color: '#065F46' },
//             'CLOSED': { bg: '#F3F4F6', color: '#4B5563' }
//         }
//     };

//     // ============================================
//     // DATE FILTER FUNCTIONS
//     // ============================================
//     const getDateRange = (filter) => {
//         const now = new Date();
//         const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
//         switch(filter) {
//             case 'TODAY':
//                 return { start: today, end: new Date(today.getTime() + 86400000 - 1) };
//             case 'YESTERDAY': {
//                 const yesterday = new Date(today.getTime() - 86400000);
//                 return { start: yesterday, end: new Date(today.getTime() - 1) };
//             }
//             case 'WEEK': {
//                 const weekStart = new Date(today.getTime() - 7 * 86400000);
//                 return { start: weekStart, end: new Date(today.getTime() + 86400000 - 1) };
//             }
//             case 'CUSTOM':
//                 if (customStartDate && customEndDate) {
//                     return {
//                         start: new Date(customStartDate),
//                         end: new Date(new Date(customEndDate).getTime() + 86400000 - 1)
//                     };
//                 }
//                 return null;
//             default:
//                 return null;
//         }
//     };

//     const isDateInRange = (dateStr, range) => {
//         if (!dateStr || !range) return true;
//         const date = new Date(dateStr);
//         return date >= range.start && date <= range.end;
//     };

//     // ============================================
//     // API CALLS
//     // ============================================
//     const fetchEnquiries = async () => {
//         setLoading(true);
//         try {
//             const data = await getAllEnquiries();
            
//             const filteredData = (data || []).filter(enquiry =>
//                 STATUS_CONFIG.DISPLAY_STATUSES.includes(enquiry.leadStatus)
//             );
            
//             const sortedData = filteredData.sort((a, b) => {
//                 const dateA = new Date(a.createdAt);
//                 const dateB = new Date(b.createdAt);
//                 return dateB - dateA;
//             });
            
//             setEnquiries(sortedData);
//             calculateStats(sortedData);
//         } catch (error) {
//             console.error('Error fetching enquiries:', error);
//             alert('Failed to fetch enquiries');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchVendors = async () => {
//         try {
//             const data = await getAllVendors();
//             setVendors(data || []);
//         } catch (error) {
//             console.error('Error fetching vendors:', error);
//         }
//     };

//     const calculateStats = (data) => {
//         const total = data.length;
//         const pending = data.filter(e => e.leadStatus === 'PENDING').length;
//         const approved = data.filter(e => e.leadStatus === 'APPROVED').length;
//         const rejected = data.filter(e => e.leadStatus === 'REJECTED').length;
//         setStats({ total, pending, approved, rejected });
//     };

//     // ============================================
//     // HANDLERS
//     // ============================================
//     const handleViewEnquiry = (enquiry) => {
//         setSelectedEnquiry(enquiry);
//         setIsViewModalOpen(true);
//     };

//     const handleOpenApprove = (enquiry) => {
//         setSelectedEnquiry(enquiry);
//         setApproveComment('');
//         setIsApproveModalOpen(true);
//     };

//     const handleOpenReject = (enquiry) => {
//         setSelectedEnquiry(enquiry);
//         setRejectReason('');
//         setIsRejectModalOpen(true);
//     };

//     const handleOpenSendModal = (enquiry) => {
//         setSelectedEnquiry(enquiry);
//         setSelectedVendors([]);
//         setSelectAll(false);
//         setVendorSearchTerm('');
//         setPaymentAmount('');
//         setIsSendModalOpen(true);
//     };

//     const handleApprove = async () => {
//         try {
//             setSubmitting(true);
//             const enquiryId = selectedEnquiry.id || selectedEnquiry.enquiryId;

//             const requestBody = {
//                 leadStatus: 'APPROVED',
//                 additionalRequests: approveComment || 'Approved by manager'
//             };

//             await updateEnquiry(enquiryId, requestBody);

//             const updatedEnquiries = enquiries.map(enq =>
//                 (enq.id === enquiryId || enq.enquiryId === enquiryId)
//                     ? { ...enq, leadStatus: 'APPROVED' }
//                     : enq
//             );
//             setEnquiries(updatedEnquiries);
//             calculateStats(updatedEnquiries);

//             alert(`✅ Enquiry ${selectedEnquiry.enquiryId || selectedEnquiry.id} approved successfully!`);
//             setIsApproveModalOpen(false);
//             setSelectedEnquiry(null);
//         } catch (error) {
//             console.error('Error approving enquiry:', error);
//             alert(error.response?.data?.message || 'Failed to approve enquiry');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const handleReject = async () => {
//         if (!rejectReason.trim()) {
//             alert('Please provide a reason for rejection');
//             return;
//         }

//         try {
//             setSubmitting(true);
//             const enquiryId = selectedEnquiry.id || selectedEnquiry.enquiryId;

//             const requestBody = {
//                 leadStatus: 'REJECTED',
//                 additionalRequests: rejectReason
//             };

//             await updateEnquiry(enquiryId, requestBody);

//             const updatedEnquiries = enquiries.map(enq =>
//                 (enq.id === enquiryId || enq.enquiryId === enquiryId)
//                     ? { ...enq, leadStatus: 'REJECTED' }
//                     : enq
//             );
//             setEnquiries(updatedEnquiries);
//             calculateStats(updatedEnquiries);

//             alert(`❌ Enquiry ${selectedEnquiry.enquiryId || selectedEnquiry.id} rejected!`);
//             setIsRejectModalOpen(false);
//             setSelectedEnquiry(null);
//             setRejectReason('');
//         } catch (error) {
//             console.error('Error rejecting enquiry:', error);
//             alert(error.response?.data?.message || 'Failed to reject enquiry');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const handleVendorSelect = (vendorId) => {
//         setSelectedVendors(prev => {
//             if (prev.includes(vendorId)) {
//                 return prev.filter(id => id !== vendorId);
//             } else {
//                 return [...prev, vendorId];
//             }
//         });
//         setSelectAll(false);
//     };

//     const handleSelectAll = () => {
//         if (selectAll) {
//             setSelectedVendors([]);
//         } else {
//             const allVendorIds = filteredVendors.map(v => v.vendorId);
//             setSelectedVendors(allVendorIds);
//         }
//         setSelectAll(!selectAll);
//     };

//     const handleSendToVendors = async () => {
//         if (selectedVendors.length === 0) {
//             alert('Please select at least one vendor');
//             return;
//         }

//         setSendingEnquiry(true);
//         try {
//             let payload;

//             if (selectAll) {
//                 payload = {
//                     adminPermision: true,
//                     paymentAmount: paymentAmount || 0,
//                     assignToAll: true
//                 };
//             } else {
//                 payload = {
//                     adminPermision: true,
//                     paymentAmount: paymentAmount || 0,
//                     vendorIds: selectedVendors
//                 };
//             }

//             await sendEnquiryToVendors(selectedEnquiry.id || selectedEnquiry.enquiryId, payload);
//             alert('✅ Enquiry sent to vendors successfully!');
//             setIsSendModalOpen(false);
//             setSelectedEnquiry(null);
//             fetchEnquiries();
//         } catch (error) {
//             console.error('Error sending enquiry:', error);
//             alert(error.response?.data?.message || 'Failed to send enquiry to vendors');
//         } finally {
//             setSendingEnquiry(false);
//         }
//     };

//     const handleDateFilterChange = (e) => {
//         const value = e.target.value;
//         setDateFilter(value);
//         if (value === 'CUSTOM') {
//             setShowCustomDatePicker(true);
//         } else {
//             setShowCustomDatePicker(false);
//         }
//     };

//     const handleCustomDateApply = () => {
//         if (customStartDate && customEndDate) {
//             setShowCustomDatePicker(false);
//             // Trigger re-render with custom dates
//             setDateFilter('CUSTOM');
//         } else {
//             alert('Please select both start and end dates');
//         }
//     };

//     // ============================================
//     // FILTERS
//     // ============================================
//     const dateRange = getDateRange(dateFilter);

//     const filteredEnquiries = enquiries.filter(enquiry => {
//         // Search filter
//         const matchesSearch =
//             (enquiry.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.city || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.enquiryId || enquiry.id || '').toString().includes(searchTerm);

//         if (!matchesSearch) return false;

//         // Date filter
//         if (dateFilter === 'ALL') return true;
//         if (!dateRange) return true;

//         // Check if enquiry date is in range
//         const enquiryDate = enquiry.createdAt || enquiry.eventDate;
//         return isDateInRange(enquiryDate, dateRange);
//     });

//     const filteredVendors = vendors.filter(vendor =>
//         (vendor.registeredName || '').toLowerCase().includes(vendorSearchTerm.toLowerCase()) ||
//         (vendor.vendorId || '').toString().includes(vendorSearchTerm)
//     );

//     // ============================================
//     // FORMAT HELPERS
//     // ============================================
//     const formatDate = (dateStr) => {
//         if (!dateStr) return '-';
//         try {
//             const date = new Date(dateStr);
//             return date.toLocaleDateString('en-IN', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch {
//             return dateStr;
//         }
//     };

//     const formatCurrency = (amount) => {
//         if (!amount) return '₹0';
//         return `₹${Number(amount).toLocaleString()}`;
//     };

//     const getStatusBadge = (status) => {
//         const colors = STATUS_CONFIG.COLORS[status] || STATUS_CONFIG.COLORS['PENDING'];
//         const displayName = STATUS_CONFIG.DISPLAY_NAMES[status] || status;
        
//         return (
//             <span style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: '4px',
//                 padding: '4px 12px',
//                 borderRadius: '20px',
//                 fontSize: '11px',
//                 fontWeight: 600,
//                 background: colors.bg,
//                 color: colors.color
//             }}>
//                 {displayName}
//             </span>
//         );
//     };

//     const hasActions = (status) => {
//         return STATUS_CONFIG.ACTION_STATUSES.includes(status);
//     };

//     // ============================================
//     // EFFECTS
//     // ============================================
//     useEffect(() => {
//         fetchEnquiries();
//         fetchVendors();
//     }, []);

//     // ============================================
//     // RENDER
//     // ============================================
//     return (
//         <div style={containerStyle}>
//             {/* Header */}
//             <div style={headerStyle}>
//                 <div style={headerLeftStyle}>
//                     <div style={headerIconStyle}>
//                         <FaClipboardList size={22} />
//                     </div>
//                     <div>
//                         <h2 style={titleStyle}>Manager Approvals</h2>
//                         <p style={subtitleStyle}>Review and approve quotes from sales team</p>
//                     </div>
//                 </div>
//             </div>

//             {/* Stats Cards */}
//             <div style={statsContainerStyle}>
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
//                         <FaClipboardList style={{ color: '#4F46E5' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.total}</div>
//                         <div style={statLabelStyle}>Total</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#FEF3C7' }}>
//                         <FaClock style={{ color: '#D97706' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.pending}</div>
//                         <div style={statLabelStyle}>Pending</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
//                         <FaCheckCircle style={{ color: '#059669' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.approved}</div>
//                         <div style={statLabelStyle}>Approved</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#FEE2E2' }}>
//                         <FaTimesCircle style={{ color: '#DC2626' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.rejected}</div>
//                         <div style={statLabelStyle}>Rejected</div>
//                     </div>
//                 </div>
//             </div>

//             {/* Search and Filter */}
//             <div style={searchFilterContainerStyle}>
//                 <div style={searchContainerStyle}>
//                     <FaSearch style={searchIconStyle} />
//                     <input
//                         type="text"
//                         placeholder="Search by name, email, company, enquiry ID..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={searchInputStyle}
//                     />
//                 </div>

//                 {/* Date Filter Dropdown */}
//                 <div style={filterDropdownContainerStyle}>
//                     <select
//                         value={dateFilter}
//                         onChange={handleDateFilterChange}
//                         style={filterDropdownStyle}
//                     >
//                         <option value="ALL">📅 All Dates</option>
//                         <option value="TODAY">📅 Today</option>
//                         <option value="YESTERDAY">📅 Yesterday</option>
//                         <option value="WEEK">📅 Last 7 Days</option>
//                         <option value="CUSTOM">📅 Custom Range</option>
//                     </select>
//                 </div>

//                 {/* Custom Date Picker */}
//                 {showCustomDatePicker && (
//                     <div style={customDatePickerStyle}>
//                         <div style={customDateInputGroupStyle}>
//                             <label style={customDateLabelStyle}>From:</label>
//                             <input
//                                 type="date"
//                                 value={customStartDate}
//                                 onChange={(e) => setCustomStartDate(e.target.value)}
//                                 style={customDateInputStyle}
//                             />
//                         </div>
//                         <div style={customDateInputGroupStyle}>
//                             <label style={customDateLabelStyle}>To:</label>
//                             <input
//                                 type="date"
//                                 value={customEndDate}
//                                 onChange={(e) => setCustomEndDate(e.target.value)}
//                                 style={customDateInputStyle}
//                             />
//                         </div>
//                         <button
//                             onClick={handleCustomDateApply}
//                             style={customDateApplyStyle}
//                         >
//                             Apply
//                         </button>
//                         <button
//                             onClick={() => {
//                                 setShowCustomDatePicker(false);
//                                 setDateFilter('ALL');
//                                 setCustomStartDate('');
//                                 setCustomEndDate('');
//                             }}
//                             style={customDateCancelStyle}
//                         >
//                             Cancel
//                         </button>
//                     </div>
//                 )}
//             </div>

//             {/* Table */}
//             <div style={tableCardStyle}>
//                 {loading ? (
//                     <div style={loadingStyle}>
//                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
//                         <p>Loading enquiries...</p>
//                     </div>
//                 ) : (
//                     <div style={tableWrapperStyle}>
//                         <table style={tableStyle}>
//                             <thead>
//                                 <tr>
//                                     <th style={{ ...thStyle, width: '3%', textAlign: 'center' }}>#</th>
//                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Enquiry ID</th>
//                                     <th style={{ ...thStyle, width: '12%', textAlign: 'left' }}>Customer</th>
//                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Event</th>
//                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Date</th>
//                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>City</th>
//                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Budget</th>
//                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Status</th>
//                                     <th style={{ ...thStyle, width: '29%', textAlign: 'center' }}>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredEnquiries.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="9" style={emptyStateStyle}>
//                                             <div style={emptyStateContentStyle}>
//                                                 <FaClipboardList size={40} color="#D1D5DB" />
//                                                 <p>No enquiries found</p>
//                                                 <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
//                                                     {searchTerm ? 'Try adjusting your search terms' : 'No enquiries pending for approval'}
//                                                 </span>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     filteredEnquiries.map((enquiry, index) => (
//                                         <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
//                                                 {index + 1}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#4F46E5', fontSize: '12px' }}>
//                                                 {enquiry.enquiryId || enquiry.id || '-'}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'left' }}>
//                                                 <div style={customerCellStyle}>
//                                                     <div style={avatarStyle}>
//                                                         {(enquiry.fullName || '?')[0].toUpperCase()}
//                                                     </div>
//                                                     <div>
//                                                         <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
//                                                             {enquiry.fullName || '-'}
//                                                         </div>
//                                                         <div style={{ fontSize: '12px', color: '#6B7280' }}>
//                                                             {enquiry.email || '-'}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <span style={eventBadgeStyle}>
//                                                     {enquiry.eventType || '-'}
//                                                 </span>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px', color: '#374151' }}>
//                                                 {enquiry.event === 'EVENT'
//                                                     ? formatDate(enquiry.eventDate)
//                                                     : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <span style={cityBadgeStyle}>
//                                                     {enquiry.city || '-'}
//                                                 </span>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
//                                                 {formatCurrency(enquiry.budget)}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 {getStatusBadge(enquiry.leadStatus)}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <div style={actionGroupStyle}>
//                                                     <button
//                                                         style={viewButtonStyle}
//                                                         title="View Details"
//                                                         onClick={() => handleViewEnquiry(enquiry)}
//                                                     >
//                                                         <FaEye size={13} /> View
//                                                     </button>
//                                                     {hasActions(enquiry.leadStatus) && (
//                                                         <>
//                                                             <button
//                                                                 style={approveButtonStyle}
//                                                                 title="Approve"
//                                                                 onClick={() => handleOpenApprove(enquiry)}
//                                                             >
//                                                                 <FaCheck size={13} /> Approve
//                                                             </button>
//                                                             <button
//                                                                 style={rejectButtonStyle}
//                                                                 title="Reject"
//                                                                 onClick={() => handleOpenReject(enquiry)}
//                                                             >
//                                                                 <FaTimes size={13} /> Reject
//                                                             </button>
//                                                             <button
//                                                                 style={sendButtonStyle}
//                                                                 title="Send to Vendors"
//                                                                 onClick={() => handleOpenSendModal(enquiry)}
//                                                             >
//                                                                 <FaPaperPlane size={13} /> Send
//                                                             </button>
//                                                         </>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </div>

//             {/* ============================================ */}
//             {/* MODALS - Same as before */}
//             {/* ============================================ */}

//             {/* View Enquiry Modal */}
//             {isViewModalOpen && selectedEnquiry && (
//                 <div style={modalOverlayStyle} onClick={() => setIsViewModalOpen(false)}>
//                     <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
//                         <div style={modalHeaderStyle}>
//                             <div style={modalHeaderLeftStyle}>
//                                 <div style={modalHeaderIconStyle}>
//                                     <FaEye size={18} />
//                                 </div>
//                                 <h3 style={modalTitleStyle}>Enquiry Details - {selectedEnquiry.enquiryId || selectedEnquiry.id}</h3>
//                             </div>
//                             <button onClick={() => setIsViewModalOpen(false)} style={modalCloseStyle}>
//                                 <FaTimes />
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <div style={viewSectionStyle}>
//                                 <h4 style={viewSectionTitleStyle}>Contact Information</h4>
//                                 <div style={viewGridStyle}>
//                                     <div><strong>Name:</strong> {selectedEnquiry.fullName || '-'}</div>
//                                     <div><strong>Company:</strong> {selectedEnquiry.companyName || '-'}</div>
//                                     <div><strong>Email:</strong> {selectedEnquiry.email || '-'}</div>
//                                     <div><strong>Phone:</strong> {selectedEnquiry.phoneNumber || '-'}</div>
//                                     <div><strong>City:</strong> {selectedEnquiry.city || '-'}</div>
//                                     <div><strong>State:</strong> {selectedEnquiry.state || '-'}</div>
//                                 </div>
//                             </div>

//                             <div style={viewSectionStyle}>
//                                 <h4 style={viewSectionTitleStyle}>Enquiry Information</h4>
//                                 <div style={viewGridStyle}>
//                                     <div><strong>Source:</strong> {selectedEnquiry.source || '-'}</div>
//                                     <div><strong>Source By:</strong> {selectedEnquiry.sourceBy || '-'}</div>
//                                     <div><strong>Event:</strong> {selectedEnquiry.eventType || '-'}</div>
//                                     <div><strong>Event Date:</strong> {formatDate(selectedEnquiry.eventDate)}</div>
//                                     <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
//                                     <div><strong>Status:</strong> {getStatusBadge(selectedEnquiry.leadStatus)}</div>
//                                 </div>
//                             </div>

//                             <div style={viewSectionStyle}>
//                                 <h4 style={viewSectionTitleStyle}>Additional Details</h4>
//                                 <div style={viewGridStyle}>
//                                     <div><strong>Veg Plates:</strong> {selectedEnquiry.vegPlates || 0}</div>
//                                     <div><strong>Non-Veg Plates:</strong> {selectedEnquiry.nonVegPlates || 0}</div>
//                                     <div><strong>Mixed Plates:</strong> {selectedEnquiry.mixedPlates || 0}</div>
//                                     <div style={{ gridColumn: '1 / -1' }}>
//                                         <strong>Address:</strong> {selectedEnquiry.fullAddress || '-'}
//                                     </div>
//                                     <div style={{ gridColumn: '1 / -1' }}>
//                                         <strong>Additional Requests:</strong> {selectedEnquiry.additionalRequests || '-'}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={formActionStyle}>
//                             <button
//                                 onClick={() => setIsViewModalOpen(false)}
//                                 style={cancelButtonStyle}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Approve Modal */}
//             {isApproveModalOpen && selectedEnquiry && (
//                 <div style={modalOverlayStyle} onClick={() => setIsApproveModalOpen(false)}>
//                     <div style={{ ...modalStyle, maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
//                         <div style={modalHeaderStyle}>
//                             <div style={modalHeaderLeftStyle}>
//                                 <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #10B981, #059669)' }}>
//                                     <FaCheck size={18} />
//                                 </div>
//                                 <h3 style={modalTitleStyle}>Approve Enquiry</h3>
//                             </div>
//                             <button onClick={() => setIsApproveModalOpen(false)} style={modalCloseStyle}>
//                                 <FaTimes />
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <div style={approvalInfoStyle}>
//                                 <div><strong>Enquiry:</strong> {selectedEnquiry.enquiryId || selectedEnquiry.id}</div>
//                                 <div><strong>Customer:</strong> {selectedEnquiry.fullName}</div>
//                                 <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
//                             </div>

//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Comments (Optional)</label>
//                                 <textarea
//                                     value={approveComment}
//                                     onChange={(e) => setApproveComment(e.target.value)}
//                                     rows="3"
//                                     placeholder="Add any comments or notes for the sales team..."
//                                     style={textareaStyle}
//                                 />
//                             </div>
//                         </div>

//                         <div style={formActionStyle}>
//                             <button
//                                 onClick={() => setIsApproveModalOpen(false)}
//                                 style={cancelButtonStyle}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleApprove}
//                                 style={approveSubmitButtonStyle}
//                                 disabled={submitting}
//                             >
//                                 {submitting ? (
//                                     <>
//                                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
//                                         Approving...
//                                     </>
//                                 ) : (
//                                     <>
//                                         <FaCheck size={14} />
//                                         Confirm Approve
//                                     </>
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Reject Modal */}
//             {isRejectModalOpen && selectedEnquiry && (
//                 <div style={modalOverlayStyle} onClick={() => setIsRejectModalOpen(false)}>
//                     <div style={{ ...modalStyle, maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
//                         <div style={modalHeaderStyle}>
//                             <div style={modalHeaderLeftStyle}>
//                                 <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #EF4444, #DC2626)' }}>
//                                     <FaTimes size={18} />
//                                 </div>
//                                 <h3 style={modalTitleStyle}>Reject Enquiry</h3>
//                             </div>
//                             <button onClick={() => setIsRejectModalOpen(false)} style={modalCloseStyle}>
//                                 <FaTimes />
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <div style={approvalInfoStyle}>
//                                 <div><strong>Enquiry:</strong> {selectedEnquiry.enquiryId || selectedEnquiry.id}</div>
//                                 <div><strong>Customer:</strong> {selectedEnquiry.fullName}</div>
//                                 <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
//                             </div>

//                             <div style={formGroupStyle}>
//                                 <label style={{ ...labelStyle, color: '#EF4444' }}>Rejection Reason <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <textarea
//                                     value={rejectReason}
//                                     onChange={(e) => setRejectReason(e.target.value)}
//                                     rows="4"
//                                     placeholder="Please provide a detailed reason for rejection..."
//                                     style={textareaStyle}
//                                     required
//                                 />
//                             </div>
//                         </div>

//                         <div style={formActionStyle}>
//                             <button
//                                 onClick={() => setIsRejectModalOpen(false)}
//                                 style={cancelButtonStyle}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleReject}
//                                 style={rejectSubmitButtonStyle}
//                                 disabled={submitting || !rejectReason.trim()}
//                             >
//                                 {submitting ? (
//                                     <>
//                                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
//                                         Rejecting...
//                                     </>
//                                 ) : (
//                                     <>
//                                         <FaTimes size={14} />
//                                         Confirm Reject
//                                     </>
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Send to Vendors Modal */}
//             {isSendModalOpen && selectedEnquiry && (
//                 <div style={modalOverlayStyle} onClick={() => setIsSendModalOpen(false)}>
//                     <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
//                         <div style={modalHeaderStyle}>
//                             <div style={modalHeaderLeftStyle}>
//                                 <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)' }}>
//                                     <FaPaperPlane size={18} />
//                                 </div>
//                                 <h3 style={modalTitleStyle}>Send to Vendors</h3>
//                             </div>
//                             <button onClick={() => setIsSendModalOpen(false)} style={modalCloseStyle}>
//                                 <FaTimes />
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             {/* Enquiry Info */}
//                             <div style={sendEnquiryInfoStyle}>
//                                 <div style={sendEnquiryInfoItemStyle}>
//                                     <span style={{ fontWeight: 500 }}>Customer:</span>
//                                     <span>{selectedEnquiry.fullName}</span>
//                                 </div>
//                                 <div style={sendEnquiryInfoItemStyle}>
//                                     <span style={{ fontWeight: 500 }}>Event:</span>
//                                     <span>{selectedEnquiry.eventType}</span>
//                                 </div>
//                                 <div style={sendEnquiryInfoItemStyle}>
//                                     <span style={{ fontWeight: 500 }}>Budget:</span>
//                                     <span style={{ color: '#059669', fontWeight: 600 }}>{formatCurrency(selectedEnquiry.budget)}</span>
//                                 </div>
//                             </div>

//                             {/* Payment Amount */}
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Lead Price</label>
//                                 <input
//                                     type="number"
//                                     value={paymentAmount}
//                                     onChange={(e) => setPaymentAmount(e.target.value)}
//                                     style={inputStyle}
//                                     placeholder="Enter Lead Price"
//                                 />
//                             </div>

//                             {/* Vendor Search */}
//                             <div style={{ ...searchContainerStyle, marginBottom: '12px', marginTop: '12px' }}>
//                                 <FaSearch style={searchIconStyle} />
//                                 <input
//                                     type="text"
//                                     placeholder="Search vendors..."
//                                     value={vendorSearchTerm}
//                                     onChange={(e) => setVendorSearchTerm(e.target.value)}
//                                     style={searchInputStyle}
//                                 />
//                             </div>

//                             {/* Select All */}
//                             <div style={selectAllContainerStyle}>
//                                 <label style={selectAllLabelStyle}>
//                                     <input
//                                         type="checkbox"
//                                         checked={selectAll}
//                                         onChange={handleSelectAll}
//                                         style={checkboxStyle}
//                                     />
//                                     <span style={{ fontWeight: 600 }}>Select All Vendors</span>
//                                 </label>
//                                 <span style={{ fontSize: '12px', color: '#6B7280' }}>
//                                     {selectAll ? 'All vendors selected' : `${selectedVendors.length} selected`}
//                                 </span>
//                             </div>

//                             {/* Vendor List */}
//                             <div style={vendorListStyle}>
//                                 {filteredVendors.length === 0 ? (
//                                     <div style={noVendorsStyle}>No vendors found</div>
//                                 ) : (
//                                     filteredVendors.map(vendor => (
//                                         <label key={vendor.vendorId} style={vendorItemStyle}>
//                                             <input
//                                                 type="checkbox"
//                                                 checked={selectedVendors.includes(vendor.vendorId)}
//                                                 onChange={() => handleVendorSelect(vendor.vendorId)}
//                                                 style={checkboxStyle}
//                                             />
//                                             <div>
//                                                 <div style={{ fontWeight: 500, fontSize: '14px' }}>
//                                                     {vendor.registeredName || 'Unnamed Vendor'}
//                                                 </div>
//                                                 <div style={{ fontSize: '12px', color: '#6B7280' }}>
//                                                     {vendor.city || 'City not specified'} • {vendor.mobileNumber || 'No phone'}
//                                                 </div>
//                                             </div>
//                                         </label>
//                                     ))
//                                 )}
//                             </div>

//                             {/* Actions */}
//                             <div style={formActionStyle}>
//                                 <button
//                                     type="button"
//                                     onClick={() => setIsSendModalOpen(false)}
//                                     style={cancelButtonStyle}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="button"
//                                     onClick={handleSendToVendors}
//                                     style={sendSubmitButtonStyle}
//                                     disabled={sendingEnquiry || selectedVendors.length === 0}
//                                 >
//                                     {sendingEnquiry ? (
//                                         <>
//                                             <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
//                                             Sending...
//                                         </>
//                                     ) : (
//                                         <>
//                                             <FaPaperPlane size={14} />
//                                             Send to {selectedVendors.length} Vendor{selectedVendors.length > 1 ? 's' : ''}
//                                         </>
//                                     )}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <style>{`
//                 @keyframes spin { to { transform: rotate(360deg); } }
//                 @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(-10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes slideUp {
//                     from { opacity: 0; transform: translateY(20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//             `}</style>
//         </div>
//     );
// };

// // ─── Styles ──────────────────────────────────────────────────────

// const containerStyle = {
//     fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
//     height:"65vh"
// };

// const headerStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '24px',
//     flexWrap: 'wrap',
//     gap: '16px',
// };

// const headerLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
// };

// const headerIconStyle = {
//     width: '44px',
//     height: '44px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const titleStyle = {
//     fontSize: '24px',
//     fontWeight: 700,
//     color: '#111827',
//     margin: 0,
//     letterSpacing: '-0.5px',
// };

// const subtitleStyle = {
//     fontSize: '14px',
//     color: '#6B7280',
//     margin: '4px 0 0 0',
// };

// // Stats Styles
// const statsContainerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(4, 1fr)',
//     gap: '16px',
//     marginBottom: '20px',
// };

// const statCardStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     background: '#fff',
//     padding: '18px 20px',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     border: '1px solid #E5E7EB',
//     transition: 'all 0.2s ease',
// };

// const statIconWrapperStyle = {
//     width: '44px',
//     height: '44px',
//     borderRadius: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
// };

// const statNumberStyle = {
//     fontSize: '22px',
//     fontWeight: 700,
//     color: '#111827',
//     lineHeight: 1.2,
// };

// const statLabelStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
//     fontWeight: 500,
// };

// // Search & Filter Styles
// const searchFilterContainerStyle = {
//     display: 'flex',
//     gap: '12px',
//     marginBottom: '20px',
//     flexWrap: 'wrap',
//     alignItems: 'center',
// };

// const searchContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     flex: 1,
//     minWidth: '200px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '0 16px',
//     transition: 'all 0.2s ease',
// };

// const searchIconStyle = {
//     color: '#9CA3AF',
//     marginRight: '12px',
// };

// const searchInputStyle = {
//     flex: 1,
//     padding: '11px 0',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     color: '#111827',
// };

// // Filter Dropdown Styles
// const filterDropdownContainerStyle = {
//     minWidth: '180px',
// };

// const filterDropdownStyle = {
//     width: '100%',
//     padding: '11px 16px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     fontSize: '14px',
//     color: '#111827',
//     cursor: 'pointer',
//     outline: 'none',
//     transition: 'all 0.2s ease',
//     appearance: 'auto',
// };

// // Custom Date Picker Styles
// const customDatePickerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     padding: '8px 12px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     flexWrap: 'wrap',
//     animation: 'fadeIn 0.2s ease',
// };

// const customDateInputGroupStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px',
// };

// const customDateLabelStyle = {
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#6B7280',
// };

// const customDateInputStyle = {
//     padding: '6px 10px',
//     border: '1px solid #E5E7EB',
//     borderRadius: '6px',
//     fontSize: '13px',
//     outline: 'none',
//     background: '#fff',
//     color: '#111827',
// };

// const customDateApplyStyle = {
//     padding: '6px 16px',
//     background: '#e66d33',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     fontSize: '13px',
//     fontWeight: 500,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const customDateCancelStyle = {
//     padding: '6px 12px',
//     background: '#F3F4F6',
//     color: '#6B7280',
//     border: 'none',
//     borderRadius: '6px',
//     fontSize: '13px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// // Table Styles
// const tableCardStyle = {
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     overflow: 'hidden',
//     border: '1px solid #E5E7EB',
// };

// const tableWrapperStyle = {
//     overflowX: 'auto',
//     padding: '0',
//     maxHeight: '60vh',
//     overflowY: 'auto',
//     scrollbarWidth:"thin"
// };

// const tableStyle = {
//     width: '100%',
//     borderCollapse: 'collapse',
//     minWidth: '1100px',
// };

// const thStyle = {
//     padding: '12px 16px',
//     fontSize: '12px',
//     fontWeight: 600,
//     color: '#6B7280',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     background: '#F9FAFB',
//     borderBottom: '1px solid #E5E7EB',
//     position: 'sticky',
//     top: 0,
//     zIndex: 10,
// };

// const tdStyle = {
//     padding: '12px 16px',
//     fontSize: '13px',
//     color: '#111827',
//     borderBottom: '1px solid #F3F4F6',
// };

// const tableRowStyle = {
//     transition: 'background 0.15s ease',
//     cursor: 'default',
// };

// const customerCellStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
// };

// const avatarStyle = {
//     width: '32px',
//     height: '32px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #e66d33, #d45a2a)',
//     color: '#fff',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '13px',
//     fontWeight: 600,
//     flexShrink: 0,
// };

// const eventBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#F3F4F6',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4B5563',
// };

// const cityBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#EEF2FF',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4F46E5',
// };

// // Action Buttons
// const actionGroupStyle = {
//     display: 'flex',
//     gap: '6px',
//     justifyContent: 'center',
//     flexWrap: 'wrap',
// };

// const viewButtonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '5px 12px',
//     background: '#60A5FA',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '12px',
//     fontWeight: 500,
//     transition: 'all 0.2s ease',
// };

// const approveButtonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '5px 12px',
//     background: '#10B981',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '12px',
//     fontWeight: 500,
//     transition: 'all 0.2s ease',
// };

// const rejectButtonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '5px 12px',
//     background: '#EF4444',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '12px',
//     fontWeight: 500,
//     transition: 'all 0.2s ease',
// };

// const sendButtonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '5px 12px',
//     background: '#8B5CF6',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '12px',
//     fontWeight: 500,
//     transition: 'all 0.2s ease',
// };

// // Empty State
// const emptyStateStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     borderBottom: 'none',
// };

// const emptyStateContentStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '8px',
// };

// const loadingStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '12px',
//     color: '#6B7280',
// };

// // Modal Styles
// const modalOverlayStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(0,0,0,0.5)',
//     backdropFilter: 'blur(4px)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999,
//     padding: '20px',
//     animation: 'fadeIn 0.25s ease',
// };

// const modalStyle = {
//     background: '#fff',
//     borderRadius: '16px',
//     width: '100%',
//     maxWidth: '720px',
//     maxHeight: '90vh',
//     overflow: 'auto',
//     boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
//     animation: 'slideUp 0.3s ease',
// };

// const modalHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '20px 24px',
//     borderBottom: '1px solid #F3F4F6',
//     position: 'sticky',
//     top: 0,
//     background: '#fff',
//     zIndex: 1,
// };

// const modalHeaderLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
// };

// const modalHeaderIconStyle = {
//     width: '36px',
//     height: '36px',
//     borderRadius: '10px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const modalTitleStyle = {
//     margin: 0,
//     fontSize: '18px',
//     fontWeight: 700,
//     color: '#111827',
// };

// const modalCloseStyle = {
//     background: '#F3F4F6',
//     border: 'none',
//     fontSize: '16px',
//     cursor: 'pointer',
//     color: '#6B7280',
//     padding: '6px 10px',
//     borderRadius: '8px',
//     transition: 'all 0.2s ease',
// };

// const modalBodyStyle = {
//     padding: '24px',
// };

// // View Styles
// const viewSectionStyle = {
//     border: '1px solid #F3F4F6',
//     borderRadius: '8px',
//     padding: '14px 16px',
//     marginBottom: '12px',
// };

// const viewSectionTitleStyle = {
//     margin: '0 0 10px 0',
//     fontSize: '14px',
//     fontWeight: 600,
//     color: '#1E293B',
// };

// const viewGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '8px 16px',
// };

// // Form Styles
// const formGroupStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '5px',
//     marginBottom: '16px',
// };

// const labelStyle = {
//     fontSize: '13px',
//     fontWeight: 500,
//     color: '#374151',
// };

// const inputStyle = {
//     padding: '10px 12px',
//     border: '1px solid #E5E7EB',
//     borderRadius: '8px',
//     fontSize: '14px',
//     outline: 'none',
//     transition: 'all 0.2s ease',
//     background: '#fff',
//     color: '#111827',
// };

// const textareaStyle = {
//     padding: '10px 12px',
//     border: '1px solid #E5E7EB',
//     borderRadius: '8px',
//     fontSize: '14px',
//     outline: 'none',
//     transition: 'all 0.2s ease',
//     background: '#fff',
//     color: '#111827',
//     resize: 'vertical',
//     fontFamily: 'inherit',
//     width: '100%',
// };

// const formActionStyle = {
//     display: 'flex',
//     gap: '12px',
//     justifyContent: 'flex-end',
//     marginTop: '8px',
//     paddingTop: '16px',
//     borderTop: '1px solid #F3F4F6',
// };

// const cancelButtonStyle = {
//     padding: '10px 24px',
//     background: '#F3F4F6',
//     color: '#4B5563',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 500,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const approveSubmitButtonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 28px',
//     background: 'linear-gradient(135deg, #10B981, #059669)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
// };

// const rejectSubmitButtonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 28px',
//     background: 'linear-gradient(135deg, #EF4444, #DC2626)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
// };

// const sendSubmitButtonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 28px',
//     background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)',
// };

// // Approval Info
// const approvalInfoStyle = {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr 1fr',
//     gap: '12px',
//     padding: '12px 16px',
//     background: '#F9FAFB',
//     borderRadius: '8px',
//     marginBottom: '16px',
//     border: '1px solid #E5E7EB',
// };

// // Send to Vendors Styles
// const sendEnquiryInfoStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(3, 1fr)',
//     gap: '12px',
//     padding: '12px 16px',
//     background: '#F9FAFB',
//     borderRadius: '8px',
//     marginBottom: '16px',
//     border: '1px solid #E5E7EB',
// };

// const sendEnquiryInfoItemStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '2px',
//     fontSize: '13px',
// };

// const selectAllContainerStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '8px 12px',
//     background: '#F9FAFB',
//     borderRadius: '8px',
//     border: '1px solid #E5E7EB',
//     marginBottom: '12px',
// };

// const selectAllLabelStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
// };

// const checkboxStyle = {
//     width: '16px',
//     height: '16px',
//     accentColor: '#e66d33',
//     cursor: 'pointer',
// };

// const vendorListStyle = {
//     maxHeight: '250px',
//     overflowY: 'auto',
//     border: '1px solid #E5E7EB',
//     borderRadius: '8px',
//     padding: '4px',
// };

// const vendorItemStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     padding: '10px 12px',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     borderBottom: '1px solid #F3F4F6',
// };

// const noVendorsStyle = {
//     padding: '20px',
//     textAlign: 'center',
//     color: '#9CA3AF',
//     fontSize: '14px',
// };

// export default ManagerApproval;


import React, { useState, useEffect, useRef } from 'react';
import {
    FaEye, FaCheck, FaTimes, FaUndo, FaPaperPlane,
    FaSearch, FaSpinner, FaUsers, FaClipboardList,
    FaClock, FaCheckCircle, FaTimesCircle, FaSync,
    FaBuilding, FaUser, FaEnvelope, FaPhone,
    FaChevronDown, FaChevronUp, FaEdit, FaTrash,
    FaCalendarAlt
} from 'react-icons/fa';
import {
    getAllEnquiries,
    updateEnquiry,
    getAllVendors,
    sendEnquiryToVendors
} from '../../../Servicefile/salesService';

const ManagerApproval = () => {
    // ============================================
    // STATE
    // ============================================
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    // Date filter state
    const [dateFilter, setDateFilter] = useState('ALL'); // ALL, TODAY, YESTERDAY, WEEK, CUSTOM
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    const [isCustomDateModalOpen, setIsCustomDateModalOpen] = useState(false);

    // Modal states
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [isSendModalOpen, setIsSendModalOpen] = useState(false);

    // Form states
    const [approveComment, setApproveComment] = useState('');
    const [rejectReason, setRejectReason] = useState('');

    // Send to vendors states
    const [vendors, setVendors] = useState([]);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [vendorSearchTerm, setVendorSearchTerm] = useState('');
    const [selectAll, setSelectAll] = useState(false);
    const [sendingEnquiry, setSendingEnquiry] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState('');

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        pending: 0,
        approved: 0,
        rejected: 0
    });

    // Refs
    const filterDropdownRef = useRef(null);

    // ============================================
    // STATUS CONFIGURATION
    // ============================================
    const STATUS_CONFIG = {
        DISPLAY_STATUSES: ['PENDING', 'APPROVED', 'REJECTED'],
        ACTION_STATUSES: ['PENDING'],
        DISPLAY_NAMES: {
            'PENDING': '⏳ Pending',
            'APPROVED': '✅ Approved',
            'REJECTED': '❌ Rejected',
            'PAYMENT_RECEIVED': '💰 Payment Received',
            'ASSIGNED': '📌 Assigned',
            'ACCEPT': '📥 Accept',
            'ACCEPTED': '✅ Accepted',
            'CLOSED': '📦 Closed'
        },
        COLORS: {
            'PENDING': { bg: '#FEF3C7', color: '#92400E' },
            'APPROVED': { bg: '#D1FAE5', color: '#065F46' },
            'REJECTED': { bg: '#FEE2E2', color: '#991B1B' },
            'PAYMENT_RECEIVED': { bg: '#DBEAFE', color: '#1E40AF' },
            'ASSIGNED': { bg: '#E0E7FF', color: '#3730A3' },
            'ACCEPT': { bg: '#FCE7F3', color: '#BE185D' },
            'ACCEPTED': { bg: '#D1FAE5', color: '#065F46' },
            'CLOSED': { bg: '#F3F4F6', color: '#4B5563' }
        }
    };

    // ============================================
    // DATE FILTER FUNCTIONS
    // ============================================
    const getDateRange = (filter) => {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
        switch(filter) {
            case 'TODAY':
                return { start: today, end: new Date(today.getTime() + 86400000 - 1) };
            case 'YESTERDAY': {
                const yesterday = new Date(today.getTime() - 86400000);
                return { start: yesterday, end: new Date(today.getTime() - 1) };
            }
            case 'WEEK': {
                const weekStart = new Date(today.getTime() - 7 * 86400000);
                return { start: weekStart, end: new Date(today.getTime() + 86400000 - 1) };
            }
            case 'CUSTOM':
                if (customStartDate && customEndDate) {
                    return {
                        start: new Date(customStartDate),
                        end: new Date(new Date(customEndDate).getTime() + 86400000 - 1)
                    };
                }
                return null;
            default:
                return null;
        }
    };

    const isDateInRange = (dateStr, range) => {
        if (!dateStr || !range) return true;
        const date = new Date(dateStr);
        return date >= range.start && date <= range.end;
    };

    // ============================================
    // API CALLS
    // ============================================
    const fetchEnquiries = async () => {
        setLoading(true);
        try {
            const data = await getAllEnquiries();
            
            const filteredData = (data || []).filter(enquiry =>
                STATUS_CONFIG.DISPLAY_STATUSES.includes(enquiry.leadStatus)
            );
            
            const sortedData = filteredData.sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB - dateA;
            });
            
            setEnquiries(sortedData);
            calculateStats(sortedData);
        } catch (error) {
            console.error('Error fetching enquiries:', error);
            alert('Failed to fetch enquiries');
        } finally {
            setLoading(false);
        }
    };

    const fetchVendors = async () => {
        try {
            const data = await getAllVendors();
            setVendors(data || []);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    const calculateStats = (data) => {
        const total = data.length;
        const pending = data.filter(e => e.leadStatus === 'PENDING').length;
        const approved = data.filter(e => e.leadStatus === 'APPROVED').length;
        const rejected = data.filter(e => e.leadStatus === 'REJECTED').length;
        setStats({ total, pending, approved, rejected });
    };

    // ============================================
    // HANDLERS
    // ============================================
    const handleViewEnquiry = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setIsViewModalOpen(true);
    };

    const handleOpenApprove = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setApproveComment('');
        setIsApproveModalOpen(true);
    };

    const handleOpenReject = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setRejectReason('');
        setIsRejectModalOpen(true);
    };

    const handleOpenSendModal = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setSelectedVendors([]);
        setSelectAll(false);
        setVendorSearchTerm('');
        setPaymentAmount('');
        setIsSendModalOpen(true);
    };

    const handleApprove = async () => {
        try {
            setSubmitting(true);
            const enquiryId = selectedEnquiry.id || selectedEnquiry.enquiryId;

            const requestBody = {
                leadStatus: 'APPROVED',
                additionalRequests: approveComment || 'Approved by manager'
            };

            await updateEnquiry(enquiryId, requestBody);

            const updatedEnquiries = enquiries.map(enq =>
                (enq.id === enquiryId || enq.enquiryId === enquiryId)
                    ? { ...enq, leadStatus: 'APPROVED' }
                    : enq
            );
            setEnquiries(updatedEnquiries);
            calculateStats(updatedEnquiries);

            alert(`✅ Enquiry ${selectedEnquiry.enquiryId || selectedEnquiry.id} approved successfully!`);
            setIsApproveModalOpen(false);
            setSelectedEnquiry(null);
        } catch (error) {
            console.error('Error approving enquiry:', error);
            alert(error.response?.data?.message || 'Failed to approve enquiry');
        } finally {
            setSubmitting(false);
        }
    };

    const handleReject = async () => {
        if (!rejectReason.trim()) {
            alert('Please provide a reason for rejection');
            return;
        }

        try {
            setSubmitting(true);
            const enquiryId = selectedEnquiry.id || selectedEnquiry.enquiryId;

            const requestBody = {
                leadStatus: 'REJECTED',
                additionalRequests: rejectReason
            };

            await updateEnquiry(enquiryId, requestBody);

            const updatedEnquiries = enquiries.map(enq =>
                (enq.id === enquiryId || enq.enquiryId === enquiryId)
                    ? { ...enq, leadStatus: 'REJECTED' }
                    : enq
            );
            setEnquiries(updatedEnquiries);
            calculateStats(updatedEnquiries);

            alert(`❌ Enquiry ${selectedEnquiry.enquiryId || selectedEnquiry.id} rejected!`);
            setIsRejectModalOpen(false);
            setSelectedEnquiry(null);
            setRejectReason('');
        } catch (error) {
            console.error('Error rejecting enquiry:', error);
            alert(error.response?.data?.message || 'Failed to reject enquiry');
        } finally {
            setSubmitting(false);
        }
    };

    const handleVendorSelect = (vendorId) => {
        setSelectedVendors(prev => {
            if (prev.includes(vendorId)) {
                return prev.filter(id => id !== vendorId);
            } else {
                return [...prev, vendorId];
            }
        });
        setSelectAll(false);
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedVendors([]);
        } else {
            const allVendorIds = filteredVendors.map(v => v.vendorId);
            setSelectedVendors(allVendorIds);
        }
        setSelectAll(!selectAll);
    };

    const handleSendToVendors = async () => {
        if (selectedVendors.length === 0) {
            alert('Please select at least one vendor');
            return;
        }

        setSendingEnquiry(true);
        try {
            let payload;

            if (selectAll) {
                payload = {
                    adminPermision: true,
                    paymentAmount: paymentAmount || 0,
                    assignToAll: true
                };
            } else {
                payload = {
                    adminPermision: true,
                    paymentAmount: paymentAmount || 0,
                    vendorIds: selectedVendors
                };
            }

            await sendEnquiryToVendors(selectedEnquiry.id || selectedEnquiry.enquiryId, payload);
            alert('✅ Enquiry sent to vendors successfully!');
            setIsSendModalOpen(false);
            setSelectedEnquiry(null);
            fetchEnquiries();
        } catch (error) {
            console.error('Error sending enquiry:', error);
            alert(error.response?.data?.message || 'Failed to send enquiry to vendors');
        } finally {
            setSendingEnquiry(false);
        }
    };

    const handleDateFilterChange = (e) => {
        const value = e.target.value;
        setDateFilter(value);
        if (value === 'CUSTOM') {
            setIsCustomDateModalOpen(true);
        }
    };

    const handleCustomDateApply = () => {
        if (customStartDate && customEndDate) {
            setIsCustomDateModalOpen(false);
            setDateFilter('CUSTOM');
        } else {
            alert('Please select both start and end dates');
        }
    };

    const handleCustomDateCancel = () => {
        setIsCustomDateModalOpen(false);
        setDateFilter('ALL');
        setCustomStartDate('');
        setCustomEndDate('');
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target)) {
                // Don't close if custom modal is open
                if (!isCustomDateModalOpen) {
                    // Any outside click logic if needed
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isCustomDateModalOpen]);

    // ============================================
    // FILTERS
    // ============================================
    const dateRange = getDateRange(dateFilter);

    const filteredEnquiries = enquiries.filter(enquiry => {
        // Search filter
        const matchesSearch =
            (enquiry.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.city || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.enquiryId || enquiry.id || '').toString().includes(searchTerm);

        if (!matchesSearch) return false;

        // Date filter
        if (dateFilter === 'ALL') return true;
        if (!dateRange) return true;

        // Check if enquiry date is in range
        const enquiryDate = enquiry.createdAt || enquiry.eventDate;
        return isDateInRange(enquiryDate, dateRange);
    });

    const filteredVendors = vendors.filter(vendor =>
        (vendor.registeredName || '').toLowerCase().includes(vendorSearchTerm.toLowerCase()) ||
        (vendor.vendorId || '').toString().includes(vendorSearchTerm)
    );

    // ============================================
    // FORMAT HELPERS
    // ============================================
    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch {
            return dateStr;
        }
    };

    const formatCurrency = (amount) => {
        if (!amount) return '₹0';
        return `₹${Number(amount).toLocaleString()}`;
    };

    const getStatusBadge = (status) => {
        const colors = STATUS_CONFIG.COLORS[status] || STATUS_CONFIG.COLORS['PENDING'];
        const displayName = STATUS_CONFIG.DISPLAY_NAMES[status] || status;
        
        return (
            <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '11px',
                fontWeight: 600,
                background: colors.bg,
                color: colors.color
            }}>
                {displayName}
            </span>
        );
    };

    const hasActions = (status) => {
        return STATUS_CONFIG.ACTION_STATUSES.includes(status);
    };

    // ============================================
    // EFFECTS
    // ============================================
    useEffect(() => {
        fetchEnquiries();
        fetchVendors();
    }, []);

    // ============================================
    // RENDER
    // ============================================
    return (
        <div style={containerStyle}>
            {/* Header */}
            <div style={headerStyle}>
                <div style={headerLeftStyle}>
                    <div style={headerIconStyle}>
                        <FaClipboardList size={22} />
                    </div>
                    <div>
                        <h2 style={titleStyle}>Manager Approvals</h2>
                        <p style={subtitleStyle}>Review and approve quotes from sales team</p>
                    </div>
                </div>
            </div>

            {/* Stats Cards */}
            <div style={statsContainerStyle}>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
                        <FaClipboardList style={{ color: '#4F46E5' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.total}</div>
                        <div style={statLabelStyle}>Total</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FEF3C7' }}>
                        <FaClock style={{ color: '#D97706' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.pending}</div>
                        <div style={statLabelStyle}>Pending</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
                        <FaCheckCircle style={{ color: '#059669' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.approved}</div>
                        <div style={statLabelStyle}>Approved</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FEE2E2' }}>
                        <FaTimesCircle style={{ color: '#DC2626' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.rejected}</div>
                        <div style={statLabelStyle}>Rejected</div>
                    </div>
                </div>
            </div>

            {/* Search and Filter */}
            <div style={searchFilterContainerStyle}>
                <div style={searchContainerStyle}>
                    <FaSearch style={searchIconStyle} />
                    <input
                        type="text"
                        placeholder="Search by name, email, company, enquiry ID..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={searchInputStyle}
                    />
                </div>

                {/* Date Filter Dropdown */}
                <div style={filterDropdownContainerStyle} ref={filterDropdownRef}>
                    <select
                        value={dateFilter}
                        onChange={handleDateFilterChange}
                        style={filterDropdownStyle}
                    >
                        <option value="ALL">All Dates</option>
                        <option value="TODAY">Today</option>
                        <option value="YESTERDAY">Yesterday</option>
                        <option value="WEEK">Last 7 Days</option>
                        <option value="CUSTOM">Custom Range</option>
                    </select>
                </div>
            </div>

            {/* Table */}
            <div style={tableCardStyle}>
                {loading ? (
                    <div style={loadingStyle}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
                        <p>Loading enquiries...</p>
                    </div>
                ) : (
                    <div style={tableWrapperStyle}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={{ ...thStyle, width: '3%', textAlign: 'center' }}>#</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Enquiry ID</th>
                                    <th style={{ ...thStyle, width: '12%', textAlign: 'left' }}>Customer</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Event</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Date</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>City</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Budget</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Status</th>
                                    <th style={{ ...thStyle, width: '29%', textAlign: 'center' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEnquiries.length === 0 ? (
                                    <tr>
                                        <td colSpan="9" style={emptyStateStyle}>
                                            <div style={emptyStateContentStyle}>
                                                <FaClipboardList size={40} color="#D1D5DB" />
                                                <p>No enquiries found</p>
                                                <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                                                    {searchTerm ? 'Try adjusting your search terms' : 'No enquiries pending for approval'}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredEnquiries.map((enquiry, index) => (
                                        <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
                                                {index + 1}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#4F46E5', fontSize: '12px' }}>
                                                {enquiry.enquiryId || enquiry.id || '-'}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'left' }}>
                                                <div style={customerCellStyle}>
                                                    <div style={avatarStyle}>
                                                        {(enquiry.fullName || '?')[0].toUpperCase()}
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
                                                            {enquiry.fullName || '-'}
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: '#6B7280' }}>
                                                            {enquiry.email || '-'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={eventBadgeStyle}>
                                                    {enquiry.eventType || '-'}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px', color: '#374151' }}>
                                                {enquiry.event === 'EVENT'
                                                    ? formatDate(enquiry.eventDate)
                                                    : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={cityBadgeStyle}>
                                                    {enquiry.city || '-'}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
                                                {formatCurrency(enquiry.budget)}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                {getStatusBadge(enquiry.leadStatus)}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <div style={actionGroupStyle}>
                                                    <button
                                                        style={viewButtonStyle}
                                                        title="View Details"
                                                        onClick={() => handleViewEnquiry(enquiry)}
                                                    >
                                                        <FaEye size={13} /> View
                                                    </button>
                                                    {hasActions(enquiry.leadStatus) && (
                                                        <>
                                                            {/* <button
                                                                style={approveButtonStyle}
                                                                title="Approve"
                                                                onClick={() => handleOpenApprove(enquiry)}
                                                            >
                                                                <FaCheck size={13} /> Approve
                                                            </button> */}
                                                            <button
                                                                style={rejectButtonStyle}
                                                                title="Reject"
                                                                onClick={() => handleOpenReject(enquiry)}
                                                            >
                                                                <FaTimes size={13} /> Reject
                                                            </button>
                                                            <button
                                                                style={sendButtonStyle}
                                                                title="Send to Vendors"
                                                                onClick={() => handleOpenSendModal(enquiry)}
                                                            >
                                                                <FaPaperPlane size={13} /> Send
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* ============================================ */}
            {/* CUSTOM DATE RANGE MODAL */}
            {/* ============================================ */}
            {isCustomDateModalOpen && (
                <div style={modalOverlayStyle} onClick={handleCustomDateCancel}>
                    <div style={{ ...modalStyle, maxWidth: '450px' , padding:"10px"}} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #e66d33, #d45a2a)' }}>
                                    <FaCalendarAlt size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Select Custom Date Range</h3>
                            </div>
                            <button onClick={handleCustomDateCancel} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={customDateModalContentStyle}>
                                <div style={customDateModalGroupStyle}>
                                    <label style={customDateModalLabelStyle}>From Date</label>
                                    <input
                                        type="date"
                                        value={customStartDate}
                                        onChange={(e) => setCustomStartDate(e.target.value)}
                                        style={customDateModalInputStyle}
                                        max={customEndDate || undefined}
                                    />
                                </div>

                                <div style={customDateModalGroupStyle}>
                                    <label style={customDateModalLabelStyle}>To Date</label>
                                    <input
                                        type="date"
                                        value={customEndDate}
                                        onChange={(e) => setCustomEndDate(e.target.value)}
                                        style={customDateModalInputStyle}
                                        min={customStartDate || undefined}
                                    />
                                </div>

                                {customStartDate && customEndDate && (
                                    <div style={customDatePreviewStyle}>
                                        <span>Selected Range: </span>
                                        <strong>
                                            {new Date(customStartDate).toLocaleDateString('en-IN', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            })} - {new Date(customEndDate).toLocaleDateString('en-IN', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            })}
                                        </strong>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={handleCustomDateCancel}
                                style={cancelButtonStyle}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleCustomDateApply}
                                style={customDateApplyModalStyle}
                                disabled={!customStartDate || !customEndDate}
                            >
                                <FaCheck size={14} />
                                Apply Filter
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================ */}
            {/* OTHER MODALS - Same as before */}
            {/* ============================================ */}

            {/* View Enquiry Modal */}
            {isViewModalOpen && selectedEnquiry && (
                <div style={modalOverlayStyle} onClick={() => setIsViewModalOpen(false)}>
                    <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={modalHeaderIconStyle}>
                                    <FaEye size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Enquiry Details - {selectedEnquiry.enquiryId || selectedEnquiry.id}</h3>
                            </div>
                            <button onClick={() => setIsViewModalOpen(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Contact Information</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Name:</strong> {selectedEnquiry.fullName || '-'}</div>
                                    <div><strong>Company:</strong> {selectedEnquiry.companyName || '-'}</div>
                                    <div><strong>Email:</strong> {selectedEnquiry.email || '-'}</div>
                                    <div><strong>Phone:</strong> {selectedEnquiry.phoneNumber || '-'}</div>
                                    <div><strong>City:</strong> {selectedEnquiry.city || '-'}</div>
                                    <div><strong>State:</strong> {selectedEnquiry.state || '-'}</div>
                                </div>
                            </div>

                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Enquiry Information</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Source:</strong> {selectedEnquiry.source || '-'}</div>
                                    <div><strong>Source By:</strong> {selectedEnquiry.sourceBy || '-'}</div>
                                    <div><strong>Event:</strong> {selectedEnquiry.eventType || '-'}</div>
                                    <div><strong>Event Date:</strong> {formatDate(selectedEnquiry.eventDate)}</div>
                                    <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
                                    <div><strong>Status:</strong> {getStatusBadge(selectedEnquiry.leadStatus)}</div>
                                </div>
                            </div>

                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Additional Details</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Veg Plates:</strong> {selectedEnquiry.vegPlates || 0}</div>
                                    <div><strong>Non-Veg Plates:</strong> {selectedEnquiry.nonVegPlates || 0}</div>
                                    <div><strong>Mixed Plates:</strong> {selectedEnquiry.mixedPlates || 0}</div>
                                    <div style={{ gridColumn: '1 / -1' }}>
                                        <strong>Address:</strong> {selectedEnquiry.fullAddress || '-'}
                                    </div>
                                    <div style={{ gridColumn: '1 / -1' }}>
                                        <strong>Additional Requests:</strong> {selectedEnquiry.additionalRequests || '-'}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={() => setIsViewModalOpen(false)}
                                style={cancelButtonStyle}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Approve Modal */}
            {isApproveModalOpen && selectedEnquiry && (
                <div style={modalOverlayStyle} onClick={() => setIsApproveModalOpen(false)}>
                    <div style={{ ...modalStyle, maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #10B981, #059669)' }}>
                                    <FaCheck size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Approve Enquiry</h3>
                            </div>
                            <button onClick={() => setIsApproveModalOpen(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={approvalInfoStyle}>
                                <div><strong>Enquiry:</strong> {selectedEnquiry.enquiryId || selectedEnquiry.id}</div>
                                <div><strong>Customer:</strong> {selectedEnquiry.fullName}</div>
                                <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
                            </div>

                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Comments (Optional)</label>
                                <textarea
                                    value={approveComment}
                                    onChange={(e) => setApproveComment(e.target.value)}
                                    rows="3"
                                    placeholder="Add any comments or notes for the sales team..."
                                    style={textareaStyle}
                                />
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={() => setIsApproveModalOpen(false)}
                                style={cancelButtonStyle}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleApprove}
                                style={approveSubmitButtonStyle}
                                disabled={submitting}
                            >
                                {submitting ? (
                                    <>
                                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
                                        Approving...
                                    </>
                                ) : (
                                    <>
                                        <FaCheck size={14} />
                                        Confirm Approve
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Reject Modal */}
            {isRejectModalOpen && selectedEnquiry && (
                <div style={modalOverlayStyle} onClick={() => setIsRejectModalOpen(false)}>
                    <div style={{ ...modalStyle, maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #EF4444, #DC2626)' }}>
                                    <FaTimes size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Reject Enquiry</h3>
                            </div>
                            <button onClick={() => setIsRejectModalOpen(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={approvalInfoStyle}>
                                <div><strong>Enquiry:</strong> {selectedEnquiry.enquiryId || selectedEnquiry.id}</div>
                                <div><strong>Customer:</strong> {selectedEnquiry.fullName}</div>
                                <div><strong>Budget:</strong> {formatCurrency(selectedEnquiry.budget)}</div>
                            </div>

                            <div style={formGroupStyle}>
                                <label style={{ ...labelStyle, color: '#EF4444' }}>Rejection Reason <span style={{ color: '#EF4444' }}>*</span></label>
                                <textarea
                                    value={rejectReason}
                                    onChange={(e) => setRejectReason(e.target.value)}
                                    rows="4"
                                    placeholder="Please provide a detailed reason for rejection..."
                                    style={textareaStyle}
                                    required
                                />
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={() => setIsRejectModalOpen(false)}
                                style={cancelButtonStyle}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleReject}
                                style={rejectSubmitButtonStyle}
                                disabled={submitting || !rejectReason.trim()}
                            >
                                {submitting ? (
                                    <>
                                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
                                        Rejecting...
                                    </>
                                ) : (
                                    <>
                                        <FaTimes size={14} />
                                        Confirm Reject
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Send to Vendors Modal */}
            {isSendModalOpen && selectedEnquiry && (
                <div style={modalOverlayStyle} onClick={() => setIsSendModalOpen(false)}>
                    <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)' }}>
                                    <FaPaperPlane size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Send to Vendors</h3>
                            </div>
                            <button onClick={() => setIsSendModalOpen(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            {/* Enquiry Info */}
                            <div style={sendEnquiryInfoStyle}>
                                <div style={sendEnquiryInfoItemStyle}>
                                    <span style={{ fontWeight: 500 }}>Customer:</span>
                                    <span>{selectedEnquiry.fullName}</span>
                                </div>
                                <div style={sendEnquiryInfoItemStyle}>
                                    <span style={{ fontWeight: 500 }}>Event:</span>
                                    <span>{selectedEnquiry.eventType}</span>
                                </div>
                                <div style={sendEnquiryInfoItemStyle}>
                                    <span style={{ fontWeight: 500 }}>Budget:</span>
                                    <span style={{ color: '#059669', fontWeight: 600 }}>{formatCurrency(selectedEnquiry.budget)}</span>
                                </div>
                            </div>

                            {/* Payment Amount */}
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Lead Price</label>
                                <input
                                    type="number"
                                    value={paymentAmount}
                                    onChange={(e) => setPaymentAmount(e.target.value)}
                                    style={inputStyle}
                                    placeholder="Enter Lead Price"
                                />
                            </div>

                            {/* Vendor Search */}
                            <div style={{ ...searchContainerStyle, marginBottom: '12px', marginTop: '12px' }}>
                                <FaSearch style={searchIconStyle} />
                                <input
                                    type="text"
                                    placeholder="Search vendors..."
                                    value={vendorSearchTerm}
                                    onChange={(e) => setVendorSearchTerm(e.target.value)}
                                    style={searchInputStyle}
                                />
                            </div>

                            {/* Select All */}
                            <div style={selectAllContainerStyle}>
                                <label style={selectAllLabelStyle}>
                                    <input
                                        type="checkbox"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                        style={checkboxStyle}
                                    />
                                    <span style={{ fontWeight: 600 }}>Select All Vendors</span>
                                </label>
                                <span style={{ fontSize: '12px', color: '#6B7280' }}>
                                    {selectAll ? 'All vendors selected' : `${selectedVendors.length} selected`}
                                </span>
                            </div>

                            {/* Vendor List */}
                            <div style={vendorListStyle}>
                                {filteredVendors.length === 0 ? (
                                    <div style={noVendorsStyle}>No vendors found</div>
                                ) : (
                                    filteredVendors.map(vendor => (
                                        <label key={vendor.vendorId} style={vendorItemStyle}>
                                            <input
                                                type="checkbox"
                                                checked={selectedVendors.includes(vendor.vendorId)}
                                                onChange={() => handleVendorSelect(vendor.vendorId)}
                                                style={checkboxStyle}
                                            />
                                            <div>
                                                <div style={{ fontWeight: 500, fontSize: '14px' }}>
                                                    {vendor.registeredName || 'Unnamed Vendor'}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#6B7280' }}>
                                                    {vendor.city || 'City not specified'} • {vendor.mobileNumber || 'No phone'}
                                                </div>
                                            </div>
                                        </label>
                                    ))
                                )}
                            </div>

                            {/* Actions */}
                            <div style={formActionStyle}>
                                <button
                                    type="button"
                                    onClick={() => setIsSendModalOpen(false)}
                                    style={cancelButtonStyle}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={handleSendToVendors}
                                    style={sendSubmitButtonStyle}
                                    disabled={sendingEnquiry || selectedVendors.length === 0}
                                >
                                    {sendingEnquiry ? (
                                        <>
                                            <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
                                            Sending...
                                        </>
                                    ) : (
                                        <>
                                            <FaPaperPlane size={14} />
                                            Send to {selectedVendors.length} Vendor{selectedVendors.length > 1 ? 's' : ''}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

// ─── Styles ──────────────────────────────────────────────────────

const containerStyle = {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    height:"65vh"
};

const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '16px',
};

const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
};

const headerIconStyle = {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const titleStyle = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#111827',
    margin: 0,
    letterSpacing: '-0.5px',
};

const subtitleStyle = {
    fontSize: '14px',
    color: '#6B7280',
    margin: '4px 0 0 0',
};

// Stats Styles
const statsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
    marginBottom: '20px',
};

const statCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    background: '#fff',
    padding: '18px 20px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    border: '1px solid #E5E7EB',
    transition: 'all 0.2s ease',
};

const statIconWrapperStyle = {
    width: '44px',
    height: '44px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const statNumberStyle = {
    fontSize: '22px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2,
};

const statLabelStyle = {
    fontSize: '13px',
    color: '#6B7280',
    fontWeight: 500,
};

// Search & Filter Styles
const searchFilterContainerStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '20px',
    flexWrap: 'wrap',
    alignItems: 'center',
};

const searchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: '200px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 16px',
    transition: 'all 0.2s ease',
};

const searchIconStyle = {
    color: '#9CA3AF',
    marginRight: '12px',
};

const searchInputStyle = {
    flex: 1,
    padding: '11px 0',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    color: '#111827',
};

// Filter Dropdown Styles
const filterDropdownContainerStyle = {
    minWidth: '180px',
};

const filterDropdownStyle = {
    width: '100%',
    padding: '11px 16px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    fontSize: '14px',
    color: '#111827',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s ease',
    appearance: 'auto',
};

// Custom Date Modal Styles
const customDateModalContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
};

const customDateModalGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
};

const customDateModalLabelStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
};

const customDateModalInputStyle = {
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease',
    background: '#fff',
    color: '#111827',
    width: '100%',
};

const customDatePreviewStyle = {
    padding: '10px 12px',
    background: '#F9FAFB',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#374151',
    textAlign: 'center',
    border: '1px solid #E5E7EB',
};

const customDateApplyModalStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #e66d33, #d45a2a)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(230, 109, 51, 0.3)',
};

// Table Styles
const tableCardStyle = {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    border: '1px solid #E5E7EB',
};

const tableWrapperStyle = {
    overflowX: 'auto',
    padding: '0',
    maxHeight: '60vh',
    overflowY: 'auto',
    scrollbarWidth:"thin"
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1100px',
};

const thStyle = {
    padding: '12px 16px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#6B7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    background: '#F9FAFB',
    borderBottom: '1px solid #E5E7EB',
    position: 'sticky',
    top: 0,
    zIndex: 10,
};

const tdStyle = {
    padding: '12px 16px',
    fontSize: '13px',
    color: '#111827',
    borderBottom: '1px solid #F3F4F6',
};

const tableRowStyle = {
    transition: 'background 0.15s ease',
    cursor: 'default',
};

const customerCellStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
};

const avatarStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #e66d33, #d45a2a)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 600,
    flexShrink: 0,
};

const eventBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#F3F4F6',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4B5563',
};

const cityBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#EEF2FF',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4F46E5',
};

// Action Buttons
const actionGroupStyle = {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    flexWrap: 'wrap',
};

const viewButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '5px 12px',
    background: '#60A5FA',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
};

const approveButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '5px 12px',
    background: '#10B981',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
};

const rejectButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '5px 12px',
    background: '#EF4444',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
};

const sendButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '5px 12px',
    background: '#8B5CF6',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
};

// Empty State
const emptyStateStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    borderBottom: 'none',
};

const emptyStateContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
};

const loadingStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#6B7280',
};

// Modal Styles
const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: 'fadeIn 0.25s ease',
};

const modalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '720px',
    maxHeight: '90vh',
   
    overflow: 'auto',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
    animation: 'slideUp 0.3s ease',
};

const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 1,
};

const modalHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
};

const modalHeaderIconStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const modalTitleStyle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const modalCloseStyle = {
    background: '#F3F4F6',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '6px 10px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
};

const modalBodyStyle = {
    padding: '24px',
};

// View Styles
const viewSectionStyle = {
    border: '1px solid #F3F4F6',
    borderRadius: '8px',
    padding: '14px 16px',
    marginBottom: '12px',
};

const viewSectionTitleStyle = {
    margin: '0 0 10px 0',
    fontSize: '14px',
    fontWeight: 600,
    color: '#1E293B',
};

const viewGridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px 16px',
};

// Form Styles
const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    marginBottom: '16px',
};

const labelStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
};

const inputStyle = {
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease',
    background: '#fff',
    color: '#111827',
};

const textareaStyle = {
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease',
    background: '#fff',
    color: '#111827',
    resize: 'vertical',
    fontFamily: 'inherit',
    width: '100%',
};

const formActionStyle = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'space-between',
    marginTop:"10px",
   
    borderTop: '1px solid #F3F4F6',
};

const cancelButtonStyle = {
    padding: '10px 24px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const approveSubmitButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #10B981, #059669)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
};

const rejectSubmitButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #EF4444, #DC2626)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
};

const sendSubmitButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)',
};

// Approval Info
const approvalInfoStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '12px',
    padding: '12px 16px',
    background: '#F9FAFB',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #E5E7EB',
};

// Send to Vendors Styles
const sendEnquiryInfoStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',
    padding: '12px 16px',
    background: '#F9FAFB',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #E5E7EB',
};

const sendEnquiryInfoItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    fontSize: '13px',
};

const selectAllContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px',
    background: '#F9FAFB',
    borderRadius: '8px',
    border: '1px solid #E5E7EB',
    marginBottom: '12px',
};

const selectAllLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    fontSize: '14px',
};

const checkboxStyle = {
    width: '16px',
    height: '16px',
    accentColor: '#e66d33',
    cursor: 'pointer',
};

const vendorListStyle = {
    maxHeight: '250px',
    overflowY: 'auto',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    padding: '4px',
};

const vendorItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderBottom: '1px solid #F3F4F6',
};

const noVendorsStyle = {
    padding: '20px',
    textAlign: 'center',
    color: '#9CA3AF',
    fontSize: '14px',
};

export default ManagerApproval;